import store from "@/store"
import settingsService from "@/_services/settings-service";

export default {
    translate: function(to) {
      var newRoute = "";
      var localize = store.getters.getLocalization;
      
      switch(to){
        case "Home":
          newRoute = localize ? "Home" : "Hogar"
          break;
        case "Contact":
          newRoute = localize ? "Contact" : "Contacta"
          break;
        case "Forgot":
          newRoute = localize ? "Forgot Username" : "Olvidé mi nombre de usuario"
          break;
        case "Gutters":
          newRoute = localize ? "Gutters" : "Canalones"
          break;
        case "Gutter Repair":
          newRoute = localize ? "Gutter Repair" : "Reparación de canalones"
          break;
        case "Gutter Replace":
          newRoute = localize ? "Gutter Replacment" : "Reemplazo de canalones"
          break;
        case "Gutter Protection":
          newRoute = localize ? "Gutter Protection" : "Protección de canalones"
          break;
        case "Login":
          newRoute = localize ? "Contact" : "Acceso"
          break;
        case "Register":
          newRoute = localize ? "Register" : "Registro";
          break;
        case "Reset":
          newRoute = localize ? "Reset Password" : "Restablecer contraseña";
          break;
        case "Roofing Ice Dams":
          newRoute = localize ? "Ice Dams" : "Presas de hielo";
          break;
        case "Roofing":
          newRoute = localize ? "Roofing" : "Techumbre";
          break;
        case "Roofing Choosing":
          newRoute = localize ? "Choosing a Roofer" : "Cómo elegir un techador";
          break;
        case "Roofing Materials FAQ":
          newRoute = localize ? "Frequently Asked Questions" : "Preguntas frecuentes";
          break;
        case "Roofing Replace":
          newRoute = localize ? "Roof Replacement" : "Reemplazo de techo";
          break;
        case "Roofing Repair":
          newRoute = localize ? "Roof Repair" : "Reparaciones de techos";
          break;
        case "Roofing Signs":
          newRoute = localize ? "Roofing Signs" : "Señales para techos";
          break;
        case "Siding":
          newRoute = localize ? "Siding" : "Vía muerta";
          break;
        case "Siding Options":
          newRoute = localize ? "Siding Options" : "Opciones de revestimiento";
          break;
        case "Siding Trim Packages":
          newRoute = localize ? "Trim Packages" : "Paquetes de equipamiento";
          break;

        case "Windows":
          newRoute = localize ? "Windows" : "Ventanas";
          break;
        case "Window Energy":
          newRoute = localize ? "Window Energy" : "Energía de ventana";
          break;
        case "Window Why":
          newRoute = localize ? "Window Why" : "Ventana por qué";
          break;

        default:
          newRoute = to;
          break;
      }

      // // console.log("Route:", newRoute)
      return newRoute;
    },

    get(page) {
      var localize = store.getters.getLocalization
      var pairs = [];

      switch(page){
        case "about-home":
          pairs = this.getAbout(localize);
          break;
        case "about-insurance":
          pairs = this.getAboutInsurance(localize);
          break;
        case "about-staff":
          pairs = this.getAboutStaff(localize);
          break;
        case "contact":
          pairs = this.getContact(localize);
          break;
        case "estimate":
          pairs = this.getEstimate(localize);
          break;
        case "gutters":
          pairs = this.getGutters(localize);
          break;
        case "gutters-repair":
          pairs = this.getGuttersRepair(localize);
          break;
        case "gutters-replace":
          pairs = this.getGuttersReplace(localize);
          break;
        case "gutters-protection":
          pairs = this.getGuttersProtection(localize);
          break;
        case "home":
          pairs = this.getHome(localize);
          break;
        case "ice-dams":
          pairs = this.getIceDams(localize);
          break;
        case "logged-in":
          pairs = this.getLoggedIn(localize);
          break;
        case "log-out":
          pairs = this.getLogOut(localize);
          break;
        case "registered":
          pairs = this.getRegistered(localize);
          break;
        case "reset":
          pairs = this.getReset(localize);
          break;
        case "roof-choose":
          pairs = this.getRoofChoose(localize);
          break;
        case "roof-home":
          pairs = this.getRoofingHome(localize);
          break;
        case "roof-materials":
          pairs = this.getRoofMaterials(localize);
          break;

        case "roof-repair":
          pairs = this.getRoofRepair(localize)
          break;
        case "roof-replacement":
          pairs = this.getRoofReplace(localize)
          break;
        case "roof-signs":
          pairs = this.getRoofSigns(localize)
          break;
        case "siding":
          pairs = this.getSiding(localize)
          break;
        case "siding-options":
          pairs = this.getSidingOptions(localize)
          break;
        case "trim":
          pairs = this.getTrim(localize)
          break;
        case "verified":
          pairs = this.getVerified(localize)
          break;
        case "windows":
          pairs = this.getWindows(localize)
          break;
        case "window-energy":
          pairs = this.getWindowEnergy(localize)
          break;
        case "window-replace":
          pairs = this.getWindowReplace(localize)
          break;

        default:
          break;
      }

      pairs.push({
        id: "company",
        text: localize ? "AquaDuct Roofing & Exteriors" : "Techos y exteriores AquaDuct",
      });
      pairs.push({
        id: "contact",
        text: localize ? "Contact Us" : "Contacta con nosotros",
      });
      pairs.push({
        id: "site-map",
        text: localize ? "Site Map" : "Mapa del Sitio",
      });
      pairs.push({
        id: "local",
        text: localize ? "English" : "Espanola",
      })

      return pairs;
    },

    getAbout(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "About Us" 
          : "Sobre nosotros",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Don’t trust your most valuable asset to just any roofing company with a truck. " 
          : "No confíe su activo más valioso a cualquier empresa de techado con un camión.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "has proudly served the Colorado Front Range for over 40 years. We are family-owned and operated, and adhere to the highest standards for quality installations and customer service." 
          : "Llevamos más de 40 años sirviendo con orgullo a la Cordillera Frontal de Colorado. Somos una empresa familiar que cumple con los más altos estándares de calidad en instalaciones y servicio al cliente.",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Long-time customers may remember us as A-1 Home Contractors, with an office for many years on West Alameda Avenue in Denver. We’re the same company, still owned by Scott Lawrence, son of Bill Lawrence, who started the company in 1972. In 1992, we expanded into Southern Colorado, providing the same excellent products and services to families all along the Front Range." 
          : "Los clientes de toda la vida quizá nos recuerden como A-1 Home Contractors, con una oficina durante muchos años en West Alameda Avenue en Denver. Somos la misma empresa, propiedad de Scott Lawrence, hijo de Bill Lawrence, quien la fundó en 1972. En 1992, nos expandimos al sur de Colorado, ofreciendo los mismos productos y servicios de excelencia a las familias de toda la región de Front Range.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Certifications That Set Us Apart from Other Roofing Contractors" 
          : "Certificaciones que nos distinguen de otros contratistas de techos",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "You should expect roofing contractors to install the best materials available, using the best techniques. That’s why" 
          : "Debe esperar que los contratistas de techos instalen los mejores materiales disponibles y utilicen las mejores técnicas. Por eso",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "proudly carries quality products from the following manufacturers, and is certified in the latest installation techniques for each." 
          : "Llevamos con orgullo productos de calidad de los siguientes fabricantes y estamos certificados en las últimas técnicas de instalación para cada uno de ellos.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Manufacturers will only honor a warranty if the installation was completed by one of their factory-certified roofing contractors, so our ongoing certifications provide an important benefit for our customers. Even if a non-certified roofing contractor installs these products to manufacturer specifications, he will not be able to offer you the warranty protection you’ll get from AquaDuct!" 
          : "Los fabricantes solo garantizan la garantía si la instalación la realizó un contratista de techos certificado por la fábrica, por lo que nuestras certificaciones continuas ofrecen un importante beneficio a nuestros clientes. Incluso si un contratista de techos no certificado instala estos productos según las especificaciones del fabricante, no podrá ofrecerle la protección de garantía que le ofrece AquaDuct.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Get an estimate from the best roofing contractors" 
          : "Obtenga un presupuesto de los mejores contratistas de techos.",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "If you’re tired of leaky roofing, gutter cleaning, ice dam build-up or having water drips damage your siding, it’s time to give" 
          : "Si está cansado de goteras en el techo, limpieza de canaletas, acumulación de hielo o goteos de agua que dañan su revestimiento, es hora de dar un paso al costado",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "a call at" 
          : "una llamada al",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? ". For more information on our service areas, including Denver, Colorado Springs, Castle Rock, Pueblo and Peyton" 
          : "Para obtener más información sobre nuestras áreas de servicio, incluidas Denver, Colorado Springs, Castle Rock, Pueblo y Peyton",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });
      pairs.push({
        id: "",
        text: localize ? "" 
          : "",
      });

      return pairs;
    },

    getAboutInsurance(localize) { 
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "License & Insurance" 
          : "Licencia y Seguro",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Proof of current licensing and proper insurance coverage should be part of any hiring process for the a roofing contractor you consider. A good roofing contractor will be happy to show you copies of these certificates and licenses." 
          : "Un comprobante de licencia vigente y una cobertura de seguro adecuada debe formar parte de cualquier proceso de contratación del contratista de techos que considere. Un buen contratista de techos estará encantado de mostrarle copias de estos certificados y licencias.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "These certifications ensure you hire a roofer who doesn’t cut corners and is able to meet the requirements of our state and local building departments. Sadly, homeowners who do not take these protective measures risk having workers who are not properly trained working on their home, damage to their property, and even financial responsibility should one of the contractor’s employees become injured on the job." 
          : "Estas certificaciones le garantizan contratar a un techador que no escatima en gastos y cumple con los requisitos de nuestros departamentos de construcción estatales y locales. Lamentablemente, los propietarios que no toman estas medidas de protección se arriesgan a tener trabajadores sin la capacitación adecuada trabajando en su hogar, a sufrir daños a su propiedad e incluso a asumir responsabilidades financieras si uno de los empleados del contratista se lesiona en el trabajo.",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Your home is one of your most important investments, and" 
          : "Su casa es una de sus inversiones más importantes y",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "understands. Every single job we start has the proper permits, licensing and insurance in place before we ever set foot on your roof." 
          : "Lo entendemos. Cada trabajo que iniciamos cuenta con los permisos, licencias y seguros necesarios antes de poner un pie en su techo.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Get an estimate from a licensed & insured roofing contractor" 
          : "Obtenga un presupuesto de un contratista de techos autorizado y asegurado",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Contact our office at" 
          : "Póngase en contacto con nuestra oficina en",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "for a FREE estimate on your roofing project, or complete the form on this page. We’d be pleased to schedule a mutually convenient time to meet with you." 
          : "Para obtener un presupuesto GRATUITO para su proyecto de techado, o complete el formulario en esta página. Con gusto programaremos una cita que nos convenga.",
      });

      return pairs;
    },

    getAboutStaff(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Meet Our Staff" 
          : "Conozca a nuestro personal",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Office Manager" 
          : "Gerente de oficina",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Production Manager" 
          : "Gerente de Producción",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Lead Roofer" 
          : "Techador líder",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "Administrative Assistant" 
          : "Asistente Administrativa",
      });
      pairs.push({
        id: "p-1.5",
        text: localize ? "Salesman" 
          : "Vendedor",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Mission Statement" 
          : "Declaración de misión",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "The mission of" 
          : "la misión de",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "is to provide superior installation services of quality exterior building products to homeowners while maintaining the highest ethical standards. To do this, we will:" 
          : "Nuestro objetivo es brindar servicios superiores de instalación de productos de construcción exterior de calidad a propietarios de viviendas, manteniendo los más altos estándares éticos. Para lograrlo, haremos lo siguiente:",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Demonstrate respect for our customers, suppliers and our fellow team members." 
          : "Demostrar respeto por nuestros clientes, proveedores y compañeros de equipo.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Give our customers the best possible service." 
          : "Brindar a nuestros clientes el mejor servicio posible.",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Achieve excellence in everything we do." 
          : "Lograr la excelencia en todo lo que hacemos.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Certifications" 
          : "Certificaciones",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "You should expect roofing contractors to install the best materials available, using the best techniques. That’s why" 
          : "Debe esperar que los contratistas de techos instalen los mejores materiales disponibles y utilicen las mejores técnicas. Por eso",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "proudly carries quality products from the following manufacturers, and is certified in the latest installation techniques for each." 
          : "Llevamos con orgullo productos de calidad de los siguientes fabricantes y estamos certificados en las últimas técnicas de instalación para cada uno de ellos.",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "Our ongoing certifications provide an important benefit for our customers: manufacturers will only honor a warranty if the installation was completed by a factory-certified contractor. Even if a non-certified roofing contractor installs these products to manufacturer specifications, he will not be able to offer you the warranty protection you’ll get from AquaDuct!" 
          : "Nuestras certificaciones continuas ofrecen un importante beneficio a nuestros clientes: los fabricantes solo cumplirán con la garantía si la instalación fue realizada por un contratista certificado por la fábrica. Incluso si un contratista de techos no certificado instala estos productos según las especificaciones del fabricante, no podrá ofrecerle la protección de garantía que le ofrece AquaDuct.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Get an estimate from the best roofing contractors" 
          : "Obtenga un presupuesto de los mejores contratistas de techos.",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "For superior installation of quality exterior building products, there’s no better choice. Give" 
          : "Para una instalación superior de productos de construcción exterior de calidad, no hay mejor opción.",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "a call today at" 
          : "una llamada hoy al",
      });
      pairs.push({
        id: "P-4.3",
        text: localize ? "to see why others have been raving about our work for years and years. We look forward to serving your home improvement needs." 
          : "Para que veas por qué otros han elogiado nuestro trabajo durante años. Esperamos poder atender tus necesidades de mejoras para el hogar.",
      });

      return pairs;
    }, 

    getContact(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Locations" : "Ubicaciones",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Contact" : "Contacta",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "at" : "en",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "for a FREE estimate on your Denver, Colorado Springs, Castle Rock, Pueblo, or Peyton roofing, gutter replacement, siding or window replacement project. Or simply complete the request form on this page. We’d be pleased to schedule a mutually convenient time to meet with you." 
          : "Para obtener un presupuesto GRATUITO para su proyecto de techo, reemplazo de canaletas, revestimiento o reemplazo de ventanas en Denver, Colorado Springs, Castle Rock, Pueblo o Peyton, o simplemente complete el formulario de solicitud en esta página. Con gusto programaremos una cita que nos convenga.",
      });
      pairs.push({
        id: "p-2",
        text: localize ? "Contact us tool free at" : "Contáctenos sin costo en",
      });

      return pairs;
    },

    getEstimate(localize) {
      var pairs = [];

      pairs.push({
        id: "title",
        text: localize ? "Request Your Free Estimate" : "Solicite su presupuesto gratuito",
      });
      pairs.push({
        id: "name",
        text: localize ? "Name" : "Nombre",
      });
      pairs.push({
        id: "address",
        text: localize ? "Address" : "DIRECCIÓN",
      });
      pairs.push({
        id: "city",
        text: localize ? "City" : "Ciudad",
      });
      pairs.push({
        id: "zipcode",
        text: localize ? "Zipcode" : "Código postal",
      });
      pairs.push({
        id: "email",
        text: localize ? "Email" : "Correo electrónico",
      });
      pairs.push({
        id: "phone",
        text: localize ? "Phone" : "Teléfono",
      });
      pairs.push({
        id: "project",
        text: localize ? "Project Type" : "Tipo de proyecto",
      });
      pairs.push({
        id: "message",
        text: localize ? "Enter your message" : "Introduce tu mensaje",
      });
      pairs.push({
        id: "solicitor",
        text: localize ? "Solicitors, your message will be ignored." : "Oh abogados, su mensaje será ignorado.",
      });
      pairs.push({
        id: "name-required",
        text: localize ? "Name is required" : "El nombre es obligatorio",
      });
      pairs.push({
        id: "name-length",
        text: localize ? "Name must be 255 characters or less" : "El nombre debe tener 255 caracteres o menos",
      });
      pairs.push({
        id: "verify",
        text: localize ? "Enter the sum of both numbers" : "Ingrese la suma de ambos números",
      }); 

      return pairs;
    },

    getGutters(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Gutters" 
          : "Canalones",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Most people don’t realize the importance of a properly constructed gutter system because it’s out of sight and out of mind. Gutters perform the vital function of collecting water from the roof and safely dispersing it away from your home, preventing costly damage.Without this preventative measure, water runoff can cause serious harm to soffits and fascia, driveways, sidewalks, plants and landscaping, and even basement flooding and cracks in your foundation." 
          : "La mayoría de las personas no se dan cuenta de la importancia de un sistema de canaletas bien construido, ya que no se ve ni se piensa en ello. Las canaletas cumplen la función vital de recoger el agua del techo y dispersarla de forma segura fuera de la casa, evitando así daños costosos. Sin esta medida preventiva, la escorrentía puede causar graves daños a los plafones y fascias, entradas de vehículos, aceras, plantas y jardines, e incluso inundaciones en el sótano y grietas en los cimientos.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "offers a complete line of seamless gutters that won’t rust and are available in a rainbow of coordinating colors, along with professional gutter installation, gutter repair, sturdy downspouts and Leaf Relief® gutter protection. We’re your complete gutter service provider." 
          : "Ofrecemos una línea completa de canaletas sin costura que no se oxidan y están disponibles en una amplia gama de colores a juego, además de instalación y reparación profesional de canaletas, bajantes resistentes y protección Leaf Relief® para canaletas. Somos su proveedor integral de servicios de canaletas.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "We install the quality seamless gutters" 
          : "Instalamos canaletas sin costura de calidad.",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "AquaDuct’s seamless gutters are crafted from a single piece of sheet metal using a specialized metal press. We bring this machine with us to each job site, so we can produce custom lengths of gutter that match your home exactly. The benefit of a custom-made piece can be explained by simple physics. Each joint in a gutter creates a weak spot that may leak or break apart. By limiting joints from the middle of the gutter, you will have an exponentially stronger, more water-tight product. Seamless gutters have become the industry standard among professionals." 
          : "Las canaletas sin costura de AquaDuct se fabrican a partir de una sola pieza de chapa metálica mediante una prensa especializada. Llevamos esta máquina a cada obra para producir longitudes de canaleta personalizadas que se adapten perfectamente a su hogar. La ventaja de una pieza a medida se explica por una simple ley de la física. Cada junta de una canaleta crea un punto débil que puede tener fugas o romperse. Al limitar las juntas desde el centro de la canaleta, obtendrá un producto exponencialmente más resistente y hermético. Las canaletas sin costura se han convertido en el estándar de la industria entre los profesionales.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "How to avoid gutter repair" 
          : "Cómo evitar la reparación de canaletas",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "Gutters require proper gutter installation and maintenance to ensure they continue to protect your home. You should periodically clean out leaves, twigs and other debris to prevent water from pooling in the gutter and pulling away from fascia boards. Pay attention to sagging gutters; when gutters pull away from your home or do not slope properly, they will permit water overflow and pooling water inside the gutter. These conditions invite birds, mosquitoes and other pests to take up residence." 
          : "Las canaletas requieren una instalación y un mantenimiento adecuados para garantizar que sigan protegiendo su hogar. Debe limpiar periódicamente hojas, ramas y otros residuos para evitar que el agua se acumule en la canaleta y se desprenda de las tablas de la fascia. Preste atención a las canaletas hundidas; cuando se desvían de su hogar o no tienen la pendiente adecuada, el agua se desborda y se acumula dentro de la canaleta. Estas condiciones favorecen la instalación de aves, mosquitos y otras plagas.",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? " To greatly reduce the need for gutter cleanings," 
          : "Para reducir en gran medida la necesidad de limpieza de canaletas,",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "can install quality Leaf Relief gutter protection, a patented gutter cover system that mounts directly to your gutters. The perforated cover keeps out leaves, ice and snow to keeps gutters running freely, and it’s backed by a 10-year “no clog” warranty! We especially recommend this improvement if there are many trees around your home." 
          : "Puede instalar la protección de canaletas Leaf Relief de calidad, un sistema patentado de cubierta que se instala directamente en sus canaletas. La cubierta perforada impide la entrada de hojas, hielo y nieve, permitiendo que las canaletas fluyan libremente. ¡Y cuenta con una garantía antiobstrucción de 10 años! Recomendamos especialmente esta mejora si hay muchos árboles alrededor de su casa.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Get a quote for gutters" 
          : "Obtenga una cotización para canaletas",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "For a FREE quote on installation of seamless gutters or Leaf Relief gutter protection, call" 
          : "Para obtener un presupuesto GRATUITO sobre la instalación de canaletas sin costura o protección de canaletas Leaf Relief, llame al",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "today at" 
          : "hoy en",
      });
      pairs.push({
        id: "p-4.3",
        text: localize ? "For more information on our service areas, including Denver, Colorado Springs, Castle Rock, Pueblo, and Peyton kindly visit our" 
          : "Para obtener más información sobre nuestras áreas de servicio, incluidas Denver, Colorado Springs, Castle Rock, Pueblo y Peyton, visite nuestra",
      });
      pairs.push({
        id: "p-4.4",
        text: localize ? "page. Our roofers look forward to serving you!" 
          : "página. ¡Nuestros techadores esperan poder atenderle!",
      });

      return pairs;
    },

    getGuttersRepair(localize) {
      var pairs = [];

    pairs.push({
      id: "header-1",
      text: localize ? "Gutter Repair" 
        : "Reparación de canalones",
    });
    pairs.push({
      id: "p-1.1",
      text: localize ? "Homeowners frequently contact" 
        : "Los propietarios de viviendas se comunican con frecuencia",
    });
    pairs.push({
      id: "p-1.2",
      text: localize ? "for seamless gutter repair, wondering why their gutters are dripping." 
        : "para la reparación de canaletas sin costura, se pregunta por qué sus canaletas gotean.",
    });
    pairs.push({
      id: "header-2",
      text: localize ? "There are several indicators that gutters need professional attention." 
        : "Hay varios indicadores de que las canaletas necesitan atención profesional.",
    });
    pairs.push({
      id: "p-2.1",
      text: localize ? "If you notice rust on portions of the gutter trough or downspouts, water will eventually leak through the holes. It’s time to plan for gutter replacement." 
        : "Si nota óxido en partes del canalón o bajantes, es posible que el agua se filtre por los agujeros. Es hora de planificar el reemplazo de los canalones.",
    });
    pairs.push({
      id: "p-2.2",
      text: localize ? "Sometimes low-quality sealants will cause gutters to leak prematurely at corners, end pieces or downspouts." 
        : "A veces, los selladores de baja calidad pueden provocar que las canaletas tengan fugas prematuras en las esquinas, los extremos o los bajantes.",
    });
    pairs.push({
      id: "p-2.3",
      text: localize ? "If you notice gutters that sag or pull away from the fascia board, water will not be able to drain out of the gutters properly. We can reattach and adjust them so water flows freely." 
        : "Si observa que las canaletas se comban o se separan de la fascia, el agua no podrá drenar correctamente. Podemos volver a colocarlas y ajustarlas para que el agua fluya libremente.",
    });
    pairs.push({
      id: "p-2.4",
      text: localize ? "Oftentimes gutters will appear to be leaking due to clogs that cause water to flow over the edge. If this is the case, a simple cleaning will usually solve the problem." 
        : "A menudo, las canaletas parecen tener fugas debido a obstrucciones que provocan que el agua se desborde. En este caso, una simple limpieza suele solucionar el problema.",
    });
    pairs.push({
      id: "header-3",
      text: localize ? "Common gutter repairs" 
        : "Reparaciones comunes de canalones",
    });
    pairs.push({
      id: "p-3.1",
      text: localize ? "Gutters play a vital role in protecting other parts of your home from devastating water damage. The condition of your foundation, soffits and fascia, driveway, sidewalks, plants and landscaping will all be affected for better or worse. That’s why when your gutters don’t perform properly, it’s important to take care of gutter repair swiftly and professionally. The following common repairs will keep gutters working effectively." 
        : "Las canaletas son vitales para proteger otras partes de su hogar de daños devastadores causados ​​por el agua. El estado de sus cimientos, plafones y fascias, entrada para autos, aceras, plantas y jardinería se verá afectado para bien o para mal. Por eso, cuando sus canaletas no funcionan correctamente, es importante repararlas con rapidez y profesionalismo. Las siguientes reparaciones comunes mantendrán sus canaletas funcionando eficazmente.",
    });
    pairs.push({
      id: "p-3.2",
      text: localize ? "Patching a hole." 
        : "Tapando un agujero.",
    });
    pairs.push({
      id: "p-3.3",
      text: localize ? "If we find a small hole in a gutter and the remainder of your gutter system doesn’t require replacement, we can patch the hole using roofing cement. For a larger hole, we will clean the surface around the hole, cover it with a large piece of metal flashing and seal the flashing using roofing cement." 
        : "Si encontramos un pequeño agujero en una canaleta y el resto del sistema no requiere reemplazo, podemos parcharlo con cemento para techos. Si el agujero es más grande, limpiaremos la superficie circundante, la cubriremos con un trozo grande de tapajuntas metálico y lo sellaremos con cemento para techos.",
    });
    pairs.push({
      id: "p-3.4",
      text: localize ? "Fixing leaky joints." 
        : "Reparación de juntas con fugas.",
    });
    pairs.push({
      id: "p-3.5",
      text: localize ? "Over time, the joint connecting two pieces of guttering or at a corner can loosen and cause sealants to crack. In this case, gutter repair is very similar to the method used to repair a hole. The adjoining metal sections are cleaned and glued with roofing cement." 
        : "Con el tiempo, la unión entre dos piezas de canalón o en una esquina puede aflojarse y provocar grietas en los selladores. En este caso, la reparación de canalones es muy similar al método utilizado para reparar un agujero. Las secciones metálicas adyacentes se limpian y se pegan con cemento para techos.",
    });
    pairs.push({
      id: "p-3.6",
      text: localize ? "Adjusting sagging gutters." 
        : "Ajuste de canaletas caídas.",
    });
    pairs.push({
      id: "p-3.7",
      text: localize ? "Older-style gutters may have been attached using a spike-and-ferrule system, but spikes can loosen and pull out, causing the gutter to sag and overflow. We can replace spikes and adjust the gutter so that there is a slight peak in the middle, which causes water to move quickly into downspouts." 
        : "Las canaletas antiguas se fijaban con un sistema de púas y casquillos, pero estas pueden aflojarse y salirse, provocando que la canaleta se hunda y se desborde. Podemos reemplazar las púas y ajustar la canaleta para que tenga un ligero resalte en el centro, lo que facilita el flujo de agua hacia los bajantes.",
    });
    pairs.push({
      id: "header-4",
      text: localize ? "Prevent gutter cleaning with proven gutter protection" 
        : "Evite la limpieza de canaletas con una protección de canaletas probada",
    });
    pairs.push({
      id: "p-4.1",
      text: localize ? "If you have large trees near your home or experience a large volume of build-up in your gutters every year, we offer Leaf Relief® gutter protection, proven to be one of the most effective ways to prevent clogged gutters." 
        : "Si tiene árboles grandes cerca de su casa o experimenta un gran volumen de acumulación en sus canaletas cada año, ofrecemos protección para canaletas Leaf Relief®, que ha demostrado ser una de las formas más efectivas de prevenir canaletas obstruidas.",
    });
    pairs.push({
      id: "header-5",
      text: localize ? "Call AquaDuct for expert gutter repair" 
        : "Llame a AquaDuct para una reparación experta de canaletas",
    });
    pairs.push({
      id: "p-5.1",
      text: localize ? "If you need gutter repair, AquaDuct can help. Call us today at " 
        : "Si necesita reparar sus canaletas, AquaDuct puede ayudarle. Llámenos hoy mismo al",
    });
    pairs.push({
      id: "p-5.2",
      text: localize ? "If repairs aren’t feasible, we can also provide a quote on gutter replacement. For 40 years, we’ve provided professional gutter services for homeowners, kindly visit our" 
        : "Si las reparaciones no son factibles, también podemos ofrecerle un presupuesto para el reemplazo de canaletas. Durante 40 años, hemos brindado servicios profesionales de canaletas a propietarios de viviendas. Visite nuestra página web.",
    });
    pairs.push({
      id: "p-5.3",
      text: localize ? "page." 
        : "página.",
    });

    return pairs;
    },

    getGuttersReplace(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Gutter Replacement" 
          : "Reemplazo de canalones",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "When it rains heavily during a storm, water covers the entire surface area of your roofing. Hundreds of gallons of water come rushing down the roofline and without gutters, that water will simply fall off the edge of the roof. Gutters are installed on the flat surface to catch the water, then channel it to a place where it won’t cause damage." 
          : "Cuando llueve con fuerza durante una tormenta, el agua cubre toda la superficie del techo. Cientos de galones de agua se precipitan por la línea del techo y, sin canaletas, simplemente se desbordan. Las canaletas se instalan en la superficie plana para captar el agua y luego la canalizan a un lugar donde no cause daños.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Besides stopping the annoying “drip” over your patio, gutter replacement can actually prevent a number of water-related problems ranging from iced-over walkways and water damage to siding and fascia boards, to basement flooding and foundation cracks. If you see a drip, it is important to fix the problem before water starts to damage wood or landscaping." 
          : "Además de detener el molesto goteo en su patio, reemplazar las canaletas puede prevenir diversos problemas relacionados con el agua, desde pasarelas congeladas y daños por agua en revestimientos y tablas de fascia, hasta inundaciones en sótanos y grietas en los cimientos. Si observa una gotera, es importante solucionar el problema antes de que el agua comience a dañar la madera o el jardín.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Can I replace gutters" 
          : "¿Puedo reemplazar las canaletas?",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "It’s a question we hear often. Many do-it-yourself gutter replacement products are available at your local home improvement  tore. However, these are cut into eight- to 10-foot segments, king the installed gutters much more likely to leak and break. Typically these products are made out of plastic that is unable to flex and often snaps apart during cold weather. You may save some money initially, but you will likely be replacing the gutters every few years." 
          : "Es una pregunta que escuchamos a menudo. En las tiendas de bricolaje más cercanas, se pueden encontrar muchos productos para reemplazar canaletas. Sin embargo, estos se cortan en segmentos de entre 2,4 y 3 metros, lo que aumenta la probabilidad de que las canaletas instaladas tengan fugas y se rompan. Normalmente, estos productos están hechos de plástico, que no se flexiona y suele romperse con el frío. Al principio, puede ahorrar algo de dinero, pero probablemente tendrá que reemplazar las canaletas cada pocos años.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "The short answer? While you can replace them yourself, we strongly recommend that you call a professional with proper equipment and safety in place for gutter installation." 
          : "En resumen, si bien puede reemplazarlas usted mismo, le recomendamos encarecidamente que llame a un profesional con el equipo y las medidas de seguridad adecuados para la instalación de las canaletas.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "offers a seamless gutter machine that converts sheet metal into custom lengths to fit your house perfectly. We’re experts at gutter installation. so you’ll have the peace of mind that your new gutters will offer years of trouble-free service." 
          : "Ofrecemos una máquina para canaletas sin costura que convierte láminas de metal en longitudes personalizadas para que se adapten perfectamente a su casa. Somos expertos en la instalación de canaletas, así que tendrá la tranquilidad de que sus nuevas canaletas le brindarán años de servicio sin problemas.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "How much will gutter replacement?" 
          : "¿Cuanto costará el reemplazo de canaletas?",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "There are numerous factors that come into play when pricing out a gutter replacement. Length and height of the home, risk assessment, type of metal used, number of downspouts, additional parts needed, and several other factors will all affect the cost. The best way to get a solid figure is to have a technician give you a custom quote for your home. While we cannot tell you what your gutter replacement will cost before an on-site visit, the majority of our gutter jobs fall between $700 and $1,800." 
          : "Hay numerosos factores que influyen al calcular el precio de un reemplazo de canaletas. La longitud y la altura de la casa, la evaluación de riesgos, el tipo de metal utilizado, el número de bajantes, las piezas adicionales necesarias y otros factores influyen en el costo. La mejor manera de obtener un presupuesto preciso es que un técnico le dé un presupuesto personalizado para su hogar. Si bien no podemos decirle cuánto costará el reemplazo de canaletas antes de una visita in situ, la mayoría de nuestros trabajos de canaletas oscilan entre $700 y $1,800.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Get a quote for gutter replacement" 
          : "Obtenga una cotización para el reemplazo de canaletas",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "For a FREE quote on installation of seamless gutters, call" 
          : "Para obtener un presupuesto GRATUITO sobre la instalación de canaletas sin costura, llame al",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "today at" 
          : "hoy en",
      });

    return pairs;
    },

    getGuttersProtection(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Gutter protection" 
          : "Protección de canalones",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "The Leaf Relief® gutter protection system is preferred by builders, contractors and homeowners across the country for its ability to stop clogs in gutters and downspouts. Maintaining gutters becomes so much simpler without trips up and down a ladder, scraping out slimy muck from a gutter trough!" 
          : "El sistema de protección de canaletas Leaf Relief® es el preferido por constructores, contratistas y propietarios de viviendas de todo el país por su capacidad para evitar obstrucciones en canaletas y bajantes. ¡Mantener las canaletas es mucho más sencillo, sin tener que subir y bajar escaleras para retirar la suciedad viscosa del canalón!",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Proven to keep leaves out of gutters" 
          : "Comprobado que mantiene las hojas fuera de las canaletas",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Tired of cleaning your gutters every spring and fall? No worries! " 
          : "¿Cansado de limpiar tus canaletas cada primavera y otoño? ¡No te preocupes!",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "is a certified installer of Leaf Relief gutter protection. In addition to professional gutter installation, AquaDuct can reduce the maintenance requirements of gutters by installing this system for both residential and commercial clients. While there are many competitors out there, Leaf Relief has been shown to be the best way to keep gutters clean and free of debris. Here’s why." 
          : "es instalador certificado de la protección para canaletas Leaf Relief. Además de la instalación profesional de canaletas, AquaDuct puede reducir el mantenimiento de las canaletas al instalar este sistema tanto para clientes residenciales como comerciales. Si bien existen muchos competidores, Leaf Relief ha demostrado ser la mejor manera de mantener las canaletas limpias y libres de residuos. Aquí le explicamos por qué.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Leaf Relief mounts directly to your gutter." 
          : "Leaf Relief se monta directamente en su canalón.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Leaf Relief installs simply and easily, without the need to lift shingles or drive nails into the roof. It fits most standard gutter systems." 
          : "Leaf Relief se instala de forma sencilla y fácil, sin necesidad de levantar tejas ni clavar clavos en el techo. Se adapta a la mayoría de los sistemas de canaletas estándar.",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Leaf Relief drains up to 29.7 inches of water per hour." 
          : "Leaf Relief drena hasta 29,7 pulgadas de agua por hora.",
      });
      pairs.push({
        id: "p-2.6",
        text: localize ? "This is an important consideration, because the world record amount of rainfall in one hour is 12 inches – Leaf Relief can handle more than twice that! Even if Leaf Relief is partly obstructed by wet leaves, it can still handle 19 inches of rainfall per hour – still more than 1.5 times the world record." 
          : "Esto es importante, ya que el récord mundial de lluvia en una hora es de 30 cm (12 pulgadas), ¡y Leaf Relief puede absorber más del doble! Incluso si Leaf Relief está parcialmente obstruido por hojas mojadas, puede absorber 48 cm (19 pulgadas) de lluvia por hora, más de 1,5 veces el récord mundial.",
      });
      pairs.push({
        id: "p-2.7",
        text: localize ? "Leaf Relief stays securely in place." 
          : "Leaf Relief permanece firmemente en su lugar.",
      });
      pairs.push({
        id: "p-2.8",
        text: localize ? "When it’s installed by professionally trained technicians, Leaf Relief will hold fast, even in hurricane-force winds of up to 110 mph." 
          : "Cuando lo instalan técnicos capacitados profesionalmente, Leaf Relief se mantendrá firme, incluso con vientos huracanados de hasta 110 mph.",
      });
      pairs.push({
        id: "p-2.9",
        text: localize ? "Leaf Relief is virtually invisible from street level." 
          : "Leaf Relief es prácticamente invisible desde el nivel de la calle.",
      });
      pairs.push({
        id: "p-2.10",
        text: localize ? "Because you can’t see it from the ground, you don’t need to worry about Leaf Relief gutter protection interrupting the visual appeal of your home." 
          : "Como no puede verlo desde el suelo, no necesita preocuparse de que la protección de canaletas Leaf Relief interrumpa el atractivo visual de su hogar.",
      });
      pairs.push({
        id: "p-2.11",
        text: localize ? "Leaf Relief resists pests." 
          : "Leaf Relief resiste plagas.",
      });
      pairs.push({
        id: "p-2.12",
        text: localize ? "Pest such as squirrels, birds, raccoons and insects often consider gutters as prime real estate for nests – a big problem when rain starts to fall. Leaf Relief deters damage caused by these animals." 
          : "Plagas como ardillas, pájaros, mapaches e insectos suelen considerar las canaletas como el lugar ideal para anidar, lo que supone un gran problema cuando empieza a llover. Leaf Relief previene los daños causados ​​por estos animales.",
      });
      pairs.push({
        id: "p-2.13",
        text: localize ? "Leaf Relief eliminates the need for routine gutter cleaning." 
          : "Leaf Relief elimina la necesidad de una limpieza rutinaria de canaletas.",
      });
      pairs.push({
        id: "p-2.14",
        text: localize ? "Dry material that collects on a Leaf Relief gutter guard will drift away on a gentle breeze of as little as 6 mph. Wet debris will be removed with a light, 23 mph wind." 
          : "El material seco que se acumula en un protector de canaletas Leaf Relief se dispersará con una brisa suave de tan solo 9,6 km/h. Los residuos húmedos se eliminarán con un viento suave de 37 km/h.",
      });
      pairs.push({
        id: "p-2.15",
        text: localize ? "Leaf Relief is backed by a great warranty." 
          : "Leaf Relief está respaldado por una gran garantía.",
      });
      pairs.push({
        id: "p-2.16",
        text: localize ? "When you purchase Leaf Relief and have it installed by an AquaDuct technician, you’ll enjoy the backing of the manufacturer’s 10-year, “No-Clog, No-Overflow” warranty." 
          : "Cuando compre Leaf Relief y lo instale un técnico de AquaDuct, disfrutará del respaldo de la garantía del fabricante de 10 años “sin obstrucciones y sin desbordamientos”.",
      });
      pairs.push({
        id: "p-2.17",
        text: localize ? "There are products that channel water back into the gutters which are effective at keeping out leaves and debris. Unfortunately, these methods often create massive ice dams in the winter months. Leaf Relief’s patented design prevents costly damage from ice dams and overflowing gutters." 
          : "Existen productos que canalizan el agua hacia las canaletas y que son eficaces para evitar la entrada de hojas y residuos. Desafortunadamente, estos métodos suelen crear grandes acumulaciones de hielo durante los meses de invierno. El diseño patentado de Leaf Relief previene daños costosos causados ​​por acumulaciones de hielo y desbordamientos de canaletas.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Get relief from gutter cleaning with Leaf Relief" 
          : "Obtenga alivio de la limpieza de canaletas con Leaf Relief",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "We are proud to offer our customers Leaf Relief as an addition to their current system or during gutter replacement. Be sure to ask about it at your estimate. For a FREE quote on any installation, call" 
          : "Nos enorgullece ofrecer a nuestros clientes Leaf Relief como complemento a su sistema actual o durante el reemplazo de canaletas. Asegúrese de preguntar por él al momento de su presupuesto. Para obtener un presupuesto GRATUITO para cualquier instalación, llame al",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "today at" 
          : "hoy en",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "For more information on our service areas,including Denver, Colorado Springs, Castle Rock, Pueblo and Peyton, kindly visit our" 
          : "Para obtener más información sobre nuestras áreas de servicio, incluidas Denver, Colorado Springs, Castle Rock, Pueblo y Peyton, visite nuestra",
      });
      pairs.push({
        id: "p-3.4",
        text: localize ? "page." 
          : "página.",
      });

      return pairs;
    },
    
    getHome(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Why Choose AquaDuct?" : "¿Por qué elegir AquaDuct?",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Putting Water In Its Place" : "Poniendo el agua en su lugar",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Welcome to" : "Bienvenido a",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Our Certifications Give You Peace of Mind" : "Nuestras certificaciones le brindan tranquilidad",
      });
      pairs.push({
        id: "header-5",
        text: localize ? "Request Your Free Estimate" : "Solicite su presupuesto gratuito",
      });
      pairs.push({
        id: "header-6",
        text: localize ? "Learn More" : "Más información",
      });
      pairs.push({
        id: "header-7",
        text: localize ? "Get an estimate from the best roofing contractors along the Front Range!" 
          : "¡Obtenga un presupuesto de los mejores contratistas de techados a lo largo de Front Range!",
      });
      pairs.push({
        id: "header-8",
        text: localize ? "Contact" : "Contacta",
      });
      pairs.push({
        id: "header-9",
        text: localize ? "Award-Winning Denver Roofing Contractors" : "Contratistas de techado galardonados de Denver",
      });
      pairs.push({
        id: "p-1",
        text: localize ? "Now celebrating four decades of service to homeowners in Denver, Colorado Springs, Pueblo and surrounding communities." 
        : "Celebramos cuatro décadas de servicio a los propietarios de viviendas en Denver, Colorado Springs, Pueblo y las comunidades aledañas.",
      });
      pairs.push({
        id: "p-2",
        text: localize ? "AquaDuct’s skilled craftsmen can complete any job expertly and to your complete satisfaction. Check out our certifications page." 
        : "Los técnicos cualificados de AquaDuct pueden realizar cualquier trabajo con maestría y a su completa satisfacción. Consulte nuestra página de certificaciones.",
      });
      pairs.push({
        id: "p-3",
        text: localize ? "For superior installation of quality exterior building products, there’s no better choice." 
        : "Para una instalación superior de productos de construcción exterior de calidad, no hay mejor opción.",
      });
      pairs.push({
        id: "p-4",
        text: localize ? "Now celebrating four decades of service to homeowners in Denver, Colorado Springs, Pueblo, Castle Rock, Peyton and surrounding communities. Whether you need roofing in Colorado Springs, roof repair, seamless gutters in Denver, replacement windows or siding, you can trust our local roofing contractors to complete the work skillfully and beyond your expectations. We give our customers the best possible service, and strive for excellence in everything we do. Get your ducks in a row with " + settingsService.get("applicationName") 
        : "Celebramos cuatro décadas de servicio a propietarios de viviendas en Denver, Colorado Springs, Pueblo, Castle Rock, Peyton y comunidades aledañas. Ya sea que necesite techos en Colorado Springs, reparación de techos, canaletas sin costura en Denver, reemplazo de ventanas o revestimientos, puede confiar en nuestros contratistas locales de techos para realizar el trabajo con destreza y superar sus expectativas. Brindamos a nuestros clientes el mejor servicio posible y nos esforzamos por alcanzar la excelencia en todo lo que hacemos. Con " + settingsService.get("applicationName") + ", todo está en orden.",
      });
      pairs.push({
        id: "p-5",
        text: localize ? "For superior installation of quality exterior building products, there’s no better choice. Give AquaDuct Roof and Gutters a call today at" 
        : "Para una instalación superior de productos de construcción exterior de calidad, no hay mejor opción. Llame hoy mismo a AquaDuct Roof and Gutters al",
      });
      pairs.push({
        id: "p-6",
        text: localize ? "to see why others have been raving about our work for years and years. For more information on our service areas, including Denver, Colorado Springs, Castle Rock, Pueblo and Peyton, kindly visit our" 
        : "Para ver por qué otros han elogiado nuestro trabajo durante años. Para más información sobre nuestras áreas de servicio, incluyendo Denver, Colorado Springs, Castle Rock, Pueblo y Peyton, visite nuestra página.",
      });
      pairs.push({
        id: "p-7",
        text: localize ? "page. We look forward to serving your home improvement needs." 
        : "página. Esperamos poder atender sus necesidades de mejoras para el hogar.",
      });
      pairs.push({
        id: "p-8",
        text: localize ? "Your home is your most valuable asset, and our credibility within the community is ours. At AquaDuct Roof and Gutters, we will treat your home with dignity and respect, not like a serial number on a job form. Our team will care for your home as if it was our own, and strives to leave your property better than we find it. We require a daily clean-up of each job site, along with frequent site checks. Once the job is finished, we do not consider the project complete until conducting a thorough final clean-up and a joint inspection with you. Until you are satisfied, our work is not done. AquaDuct maintains an outstanding A+ rating with the Better Business Bureau. In addition, our care and dedication to excellence has earned us the Bureau’s coveted Gold Star Award five years in a row! This recognition is given to Denver roofing companies that display excellence in customer service and have had no consumer complaints. One year with no complaints is a difficult feat in any industry, so we’re especially proud of this achievement." 
        : "Su hogar es su bien más preciado, y nuestra credibilidad en la comunidad es nuestra. En AquaDuct Roof and Gutters, trataremos su hogar con dignidad y respeto, no como un número de serie en un formulario de trabajo. Nuestro equipo cuidará de su hogar como si fuera el nuestro y nos esforzamos por dejar su propiedad en mejores condiciones que como la encontramos. Exigimos una limpieza diaria de cada obra, junto con inspecciones frecuentes. Una vez finalizado el trabajo, no lo consideramos completo hasta que realizamos una limpieza final exhaustiva y una inspección conjunta con usted. Hasta que no esté satisfecho, nuestro trabajo no está terminado. AquaDuct mantiene una excelente calificación A+ con el Better Business Bureau. Además, nuestro cuidado y dedicación a la excelencia nos han hecho merecedores del codiciado Premio Estrella de Oro del Bureau por cinco años consecutivos. Este reconocimiento se otorga a las empresas de techado de Denver que demuestran excelencia en el servicio al cliente y no han recibido quejas de los consumidores. Un año sin quejas es una hazaña difícil en cualquier industria, por lo que estamos especialmente orgullosos de este logro.",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "Now celebrating four decades of service to homeowners in Denver, Colorado Springs, Pueblo, Castle Rock, Peyton and surrounding communities. Whether you need roofing in, roof repair, seamless gutters,  replacement windows or siding, you can trust our local roofing contractors to complete the work skillfully and beyond your expectations. We give our customers the best possible service, and strive for excellence in everything we do. Get your ducks in a row with AquaDuct." 
        : "Celebramos cuatro décadas de servicio a propietarios de viviendas en Denver, Colorado Springs, Pueblo, Castle Rock, Peyton y comunidades aledañas. Ya sea que necesite instalar, reparar, instalar canaletas sin costura, reemplazar ventanas o revestimientos, puede confiar en nuestros contratistas locales de techos para realizar el trabajo con destreza y superar sus expectativas. Brindamos a nuestros clientes el mejor servicio posible y nos esforzamos por alcanzar la excelencia en todo lo que hacemos. Con AquaDuct, todo está en orden.",
      });

      return pairs;
    },

    getIceDams(localize) {
      var pairs = [];

      pairs.push({
        id: "heading-0",
        text: localize ? "Roofing ice dams" : "Techado de presas de hielo",
      });
      pairs.push({
        id: "p-1",
        text: localize ? "A roof leak due to damaged flashing or missing shingles is usually a straightforward problem to diagnose and repair. That isn’t the case with ice damming. For homes in Colorado, roof leaks caused by ice dams can be frustrating and confusing. Here’s more about this damaging phenomenon." 
          : "Una gotera en el techo debido a tapajuntas dañados o tejas faltantes suele ser un problema fácil de diagnosticar y reparar. Esto no ocurre con las represas de hielo. En Colorado, las goteras causadas por represas de hielo pueden ser frustrantes y confusas. Aquí encontrará más información sobre este fenómeno perjudicial.",
      });
      pairs.push({
        id: "p-2",
        text: localize ? "Ice dams require a “perfect storm” of conditions to form, including significant snow on the roof, sustained freezing temperatures and a poorly insulated attic. When warm air from your home escapes into the attic, the air will heat the roof deck. The heat melts snow on the upper portion of the roof, but the water refreezes as it runs down to the cold eaves and forms a ridge of ice." 
          : "Las presas de hielo requieren una combinación perfecta de condiciones para formarse, como una gran cantidad de nieve en el techo, temperaturas gélidas constantes y un ático mal aislado. Cuando el aire caliente de la casa se escapa al ático, calienta la cubierta del techo. El calor derrite la nieve en la parte superior del techo, pero el agua se vuelve a congelar al descender hacia los aleros fríos y formar una cresta de hielo.",
      });
      pairs.push({
        id: "p-3",
        text: localize ? "As this cycle continues over several days, more water pools up behind the ice dam. The dammed water may then back up under roofing materials, leaking into the attic or along exterior walls. Over time, ice damming leads to rot, ruined insulation, mold, structural problems and expensive repairs." 
          : "A medida que este ciclo continúa durante varios días, se acumula más agua detrás de la presa de hielo. El agua acumulada puede acumularse bajo los materiales del techo y filtrarse al ático o a lo largo de las paredes exteriores. Con el tiempo, la acumulación de hielo provoca podredumbre, deterioro del aislamiento, moho, problemas estructurales y costosas reparaciones.",
      });
      pairs.push({
        id: "heading-1",
        text: localize ? "Solutions to ice damming" : "Soluciones a la formación de represas de hielo",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Good roofing contractors know the secret to stopping ice dams: proper attic insulation and ventilation. In addition to heat that escapes through the attic floor, heat can escape from holes and gaps around vents, pipes, light fixtures, ceiling fans, and other ceiling penetrations. Good attic ventilation keeps warm, moist air circulating with cold outside air, preventing snow from melting on the roof deck." 
          : "Los buenos contratistas de techos conocen el secreto para evitar las acumulaciones de hielo: un aislamiento y una ventilación adecuados del ático. Además del calor que se escapa por el suelo del ático, también puede escaparse por agujeros y huecos alrededor de respiraderos, tuberías, lámparas, ventiladores de techo y otras penetraciones del techo. Una buena ventilación del ático mantiene el aire cálido y húmedo circulando con el aire frío del exterior, evitando que la nieve se derrita en la cubierta del techo.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Don’t deal with the problem yourself, call AquaDuct for assistance" 
          : "No solucione el problema usted mismo, llame a AquaDuct para obtener ayuda.",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "We don’t advise attempting snow or ice removal yourself; this can be dangerous for you and damaging to your roof! If you suspect ice damming, call" 
          : "No le recomendamos que intente retirar la nieve o el hielo usted mismo; puede ser peligroso y dañar su techo. Si sospecha que hay una acumulación de hielo, llame",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "today at" : "hoy en",
      });
      pairs.push({
        id: "p-1.5",
        text: localize ? "for an inspection. We can plan short-term and long-term solutions to stop ice dams that won’t damage your roofing!" 
          : "Para una inspección. Podemos planificar soluciones a corto y largo plazo para detener las acumulaciones de hielo sin dañar su techo.",
      });
      pairs.push({
        id: "heading-2",
        text: localize ? "Signs you need a new roof" 
          : "Señales de que necesitas un techo nuevo",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "No one wants the unexpected news that they need a new roof, so it’s always best to plan ahead for the expense. Here are some of the most common warning signs your roofing is due for replacement." 
          : "Nadie quiere la noticia inesperada de que necesita un techo nuevo, así que siempre es mejor planificar con antelación el gasto. Estas son algunas de las señales de advertencia más comunes de que su techo necesita ser reemplazado.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "Leaks or water stains." : "Fugas o manchas de agua.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Recurring leak problems often signal the need for a new roof. Wetness or water stains may be visible on interior ceilings, which can then be traced to the attic and the roof. When not caught early, leaks will lead to rot, mold and other costly problems." 
          : "Los problemas recurrentes de goteras suelen indicar la necesidad de un techo nuevo. La humedad o las manchas de agua pueden ser visibles en los techos interiores, cuyas raíces pueden rastrearse hasta el ático y el techo. Si no se detectan a tiempo, las goteras pueden provocar podredumbre, moho y otros problemas costosos.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Storm damage" : "Daños por tormenta",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Depending on the severity, storms can cause enough damage to warrant complete roof replacement. Typical types of storm damage include missing and torn shingles, damaged flashing, and bruising caused by hail impact." 
          : "Dependiendo de la gravedad, las tormentas pueden causar daños suficientes como para justificar el reemplazo completo del techo. Los daños típicos incluyen tejas faltantes o rotas, tapajuntas dañados y magulladuras causadas por el impacto del granizo.",
      });
      pairs.push({
        id: "p-2.6",
        text: localize ? "Worn shingles" : "Tejas desgastadas",
      });
      pairs.push({
        id: "p-2.7",
        text: localize ? "As shingles age, their protective granule surface gradually wears away, leaving the internal mat exposed. Watch for excessive amounts of granules in the gutters, a sign of advanced wear." 
          : "A medida que las tejas envejecen, su superficie protectora granular se desgasta gradualmente, dejando la membrana interna expuesta. Preste atención a la presencia de cantidades excesivas de gránulos en las canaletas, lo cual es una señal de desgaste avanzado.",
      });
      pairs.push({
        id: "p-2.8",
        text: localize ? "Curling or blistering shingles" : "Tejas que se enroscan o ampollan",
      });
      pairs.push({
        id: "p-2.9",
        text: localize ? "Attic ventilation problems, manufacturer defects and improper installation can ruin shingles." 
          : "Los problemas de ventilación del ático, los defectos de fabricación y la instalación incorrecta pueden arruinar las tejas.",
      });
      pairs.push({
        id: "heading-3",
        text: localize ? "Should I file a claim with my homeowner’s insurance company?" 
          : "¿Debo presentar una reclamación a la compañía de seguros de mi vivienda?",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "If you’re not sure if your roof needs to be replaced due to storm damage, call" 
          : "Si no está seguro de si su techo necesita ser reemplazado debido a daños causados ​​por tormentas, llame",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "before contacting your insurance agent. Insurance companies record your inspection requests, and may even “red flag” your account if you file too many. It may be harder to file valid claims in the future if the insurance company believes you have been trying to get a free roof replacement."
          : "Antes de contactar a su agente de seguros, las compañías de seguros registran sus solicitudes de inspección e incluso podrían marcar su cuenta como “marcada en rojo” si presenta demasiadas. Podría ser más difícil presentar reclamaciones válidas en el futuro si la compañía de seguros cree que ha estado intentando obtener un reemplazo de techo gratuito.",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "Get advice from the best roofing contractors" 
          : "Recibe consejos de los mejores contratistas de techos.",
      });
      pairs.push({
        id: "p-3.4",
        text: localize ? "It’s always best to replace an aging roof before it displays signs of failure. For honest, dependable advice about the health of your roof, contact AquaDuct today at" 
          : "Siempre es mejor reemplazar un techo viejo antes de que muestre signos de deterioro. Para obtener asesoramiento honesto y confiable sobre el estado de su techo, comuníquese con AquaDuct hoy mismo al",
      });
      pairs.push({
        id: "p-3.5",
        text: localize ? "We’re the roofing contractors homeowners turn to for exceptional service." 
          : "Somos los contratistas de techados a los que recurren los propietarios para obtener un servicio excepcional.",
      });

      return pairs;
    },

    getLoggedIn(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "User logged in" 
          : "Usuario registrado",
      });

      return pairs;
    },

    getLogOut(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Are you sure you want to logout?" 
          : "¿Estás seguro de que quieres cerrar sesión?",
      });
      pairs.push({
        id: "b-1",
        text: localize ? "Logout" 
          : "Cerrar sesión",
      });
      //  Logout
      return pairs;
    },

    getRegistered(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Account Registered" 
          : "Cuenta Registrada",
      });

      return pairs;
    },

    getReset(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Your password has been reset." 
          : "CueSu contraseña ha sido restablecida.",
      });

      return pairs;
    },

    getRoofChoose(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "How to choose a roofer" 
          : "Cómo elegir un techador",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "While it is impossible to know how satisfied you will be with a roofing company’s work until the job is completed, there are several indicators you can use to make an educated decision. During the estimate, it’s important to pay attention to the details that distinguish not-so-great roofers from great roofing contractors." 
          : "Si bien es imposible saber qué tan satisfecho estará con el trabajo de una empresa de techado hasta que esté terminado, existen varios indicadores que puede utilizar para tomar una decisión informada. Al elaborar el presupuesto, es importante prestar atención a los detalles que distinguen a los techadores menos competentes de los contratistas de techado de calidad.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Did the contractor respect your time enough to show up on schedule?" 
          : "¿El contratista respetó su tiempo lo suficiente como para presentarse a tiempo?",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Did the contractor listen carefully to your concerns and wishes for the work to be done?" 
          : "¿El contratista escuchó atentamente sus inquietudes y deseos con respecto al trabajo a realizar?",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "Was the contractor respectful of your family and your property?" 
          : "¿El contratista fue respetuoso con su familia y su propiedad?",
      });
      pairs.push({
        id: "p-1.5",
        text: localize ? "Was the contractor able to answer your questions quickly and in understandable terms?" 
          : "¿El contratista pudo responder a sus preguntas rápidamente y en términos comprensibles?",
      });
      pairs.push({
        id: "p-1.6",
        text: localize ? "Did the contractor present a written estimate within a reasonable amount of time, with all aspects of the project and pricing detailed?" 
          : "¿El contratista presentó un presupuesto por escrito dentro de un tiempo razonable, con todos los aspectos del proyecto y los precios detallados?",
      });
      pairs.push({
        id: "p-1.7",
        text: localize ? "Does the contractor have references and a good reputation locally?" 
          : "¿Tiene el contratista referencias y una buena reputación local?",
      });
      pairs.push({
        id: "p-1.8",
        text: localize ? "If you can’t say yes to all of these, it’s probably a good idea to keep looking for someone else. When roofers meet you for the first time, they are on their best behavior. When they aren’t on time, respectful or knowledgeable about their product while trying to put their best foot forward, why would they be any different when they do the work?" 
          : "Si no puede aceptar todas estas opciones, probablemente sea buena idea seguir buscando a otro profesional. Cuando un techador lo conoce por primera vez, se porta de maravilla. Si no es puntual, respetuoso o conoce bien su producto, y además intenta dar lo mejor de sí, ¿por qué habría de ser diferente al realizar el trabajo?",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Looking for the right roofers?  Reputation matters" 
          : "¿Buscas al techador adecuado? La reputación importa.",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Carelessness on the part of installers is one of the most common factors that results in an underperforming roof. And chances are good if a contractor has one poorly-executed roofing job, there are more! After a while, word of that contractor’s incompetence will spread. When you’re looking for a roofer, don’t settle for the lowest bid – take the time to listen to what past customers have to say, both online and in person. Reputable local contractors with proven knowledge and experience, backed by many verifiable customer recommendations, are the only options you should consider for your roofing project." 
          : "La falta de cuidado por parte de los instaladores es uno de los factores más comunes que resultan en un techo de bajo rendimiento. Y es muy probable que si un contratista tiene un trabajo de techado mal ejecutado, ¡hay más! Con el tiempo, se correrá la voz sobre su incompetencia. Cuando busque un techador, no se conforme con la oferta más baja; tómese el tiempo de escuchar las opiniones de clientes anteriores, tanto en línea como en persona. Los contratistas locales de buena reputación, con conocimientos y experiencia comprobados, respaldados por numerosas recomendaciones verificables de clientes, son las únicas opciones que debería considerar para su proyecto de techado.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "has served the Colorado Front Range for the past 40 years. We’re a third-generation family business with a proven reputation for “Putting Water in Its Place”! To read testimonials from just a few of our satisfied customers, click here. As further proof of our reputation." 
          : "Ha servido a la Cordillera Frontal de Colorado durante los últimos 40 años. Somos una empresa familiar de tercera generación con una reputación comprobada de 'poner el agua en su lugar'. Para leer los testimonios de algunos de nuestros clientes satisfechos, haga clic aquí. Una prueba más de nuestra reputación.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Get an estimate from the best roofing contractors in Colorado" 
          : "Obtenga un presupuesto de los mejores contratistas de techos en Colorado",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "For superior installation of quality exterior building products, there’s no better choice. Give" 
          : "Para una instalación superior de productos de construcción exterior de calidad, no hay mejor opción.",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "a call today at" 
          : "una llamada hoy al",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "to see why others have been raving about our work for years and years. For more information on our service areas, including Denver, Colorado Springs, Castle Rock, Peyton and Pueblo,  kindly visit our" 
          : "Para ver por qué otros han elogiado nuestro trabajo durante años. Para más información sobre nuestras áreas de servicio, incluyendo Denver, Colorado Springs, Castle Rock, Peyton y Pueblo, visite nuestra página.",
      });
      pairs.push({
        id: "p-3.4",
        text: localize ? "page. We look forward to serving your home improvement needs." 
          : "página. Esperamos poder atender sus necesidades de mejoras para el hogar.",
      });

      return pairs;
    },

    getRoofingHome(localize) {
      var pairs = [];
      pairs.push({
        id: "header-1",
        text: localize ? "Our roofers respect your home & family" : "Nuestros techadores respetan su hogar y familia",
      });
      pairs.push({
        id: "p-1",
        text: localize ? "provides new roofing and roof replacement for homes of any size. Our commitment to superior customer service is what sets us apart from other roofing companies, so we’ll do your job efficiently and with as little disruption to your routine as possible. In fact, most projects are completed within a day or two, and we are happy to work around your schedule." : 
          "Ofrecemos servicios de instalación y reemplazo de techos para viviendas de cualquier tamaño. Nuestro compromiso con un servicio al cliente excepcional nos distingue de otras empresas de techado, por lo que realizaremos su trabajo de manera eficiente y con la mínima interrupción posible en su rutina. De hecho, la mayoría de los proyectos se completan en uno o dos días, y nos complace adaptarnos a su horario.",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Our roofers take great care to protect your lawn and landscaping during a roofing project. We’ll place tarps to keep discarded roofing material from hitting windows and doors, and falling on delicate trees, bushes and flowers. Once the work is finished, we’ll use a special magnet to remove stray nails and roofing materials so yourlawn will once again be safe for your family and pets. Trust the professionals of " : 
          "Nuestros techadores cuidan con sumo cuidado su césped y jardín durante un proyecto de techado. Colocaremos lonas para evitar que los materiales de techado desechados golpeen ventanas y puertas, y caigan sobre árboles, arbustos y flores delicadas. Una vez finalizado el trabajo, usaremos un imán especial para retirar clavos y materiales de techado sueltos, para que su césped vuelva a ser seguro para su familia y mascotas. Confíe en los profesionales de",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "to do the job right, the first time." : "hacer el trabajo bien, la primera vez.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Top-quality materials for roof replacement & repairs" : 
          "Materiales de primera calidad para reemplazo y reparación de techos.",
      });
      pairs.push({
        id: "p-2",
        text: localize ? "Roofing is a sizable investment, so it only makes sense to utilize the best products available to replace your roof. At AquaDuct, we don’t believe in skimping on materials, which is why we utilize the premier brands in the roofing industry: Owens Corning, CertainTeed, GAF and TAMKO. The materials we use for roofing homes are typically engineered to last for several decades, ensuring the maximum amount of service life and long-lasting curb appeal." : 
          "El techado es una inversión considerable, por lo que es lógico utilizar los mejores productos disponibles para reemplazarlo. En AquaDuct, no escatimamos en materiales, por eso utilizamos las mejores marcas de la industria: Owens Corning, CertainTeed, GAF y TAMKO. Los materiales que utilizamos para techar viviendas suelen estar diseñados para durar varias décadas, lo que garantiza una vida útil máxima y un atractivo exterior duradero.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Get a free estimage for roofing your home!" : "¡Obtenga un presupuesto gratuito para techar su casa!",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "To schedule a FREE estimate for roofing your home, call" : "Para programar un presupuesto GRATUITO para el techado de su hogar, llame al",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "anytime. For  more information on our service areas, including Denver,  Colorado Springs, Peyton, Castle Rock and Pueblo, kindly visit our" 
          : "en cualquier momento. Para obtener más información sobre nuestras áreas de servicio, incluyendo Denver, Colorado Springs, Peyton, Castle Rock y Pueblo, visite nuestro",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "page. Not certain whether you need a new roof? That’s OK too – we’re the roofing contractors, homeowners turn to for honest, dependable advice. We’ll conduct a thorough inspection of your roof and explain our findings in detail. Contact AquaDuct today at" 
          : "¿No está seguro de si necesita un techo nuevo? No se preocupe, somos los contratistas de techos a los que recurren los propietarios para obtener asesoramiento honesto y confiable. Realizaremos una inspección exhaustiva de su techo y le explicaremos nuestros hallazgos en detalle. Contacte con AquaDuct hoy mismo en",
      });

      return pairs;
    },

    getRoofMaterials(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Frequently asked questions" 
          : "Preguntas frecuentes",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Your choice of material is one of the most important decisions you will make regarding your roofing project. Here’s some information to help you make the right choice for your home and your budget. For answers to home improvement questions or to schedule a FREE estimate, please call" 
          : "La elección del material es una de las decisiones más importantes que tomará en su proyecto de techado. Aquí encontrará información para ayudarle a elegir la opción adecuada para su hogar y su presupuesto. Para obtener respuestas a sus preguntas sobre mejoras en el hogar o para programar un presupuesto GRATUITO, llame al",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "today at" 
          : "hoy en",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Asphalt shingles." 
          : "Tejas de asfalto.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "The most common type of roofing material, asphalt shingles are popular because they’re affordable and versatile. Durability is another advantage: this type of shingle works in nearly any environment and lasts for many years. In recent years, manufacturers have succeeded in making asphalt shingles that mimic high-end materials such as slate and wood shakes." 
          : "Las tejas asfálticas, el material más común para techos, son populares por su precio asequible y versatilidad. Su durabilidad es otra ventaja: este tipo de teja es compatible con casi cualquier entorno y dura muchos años. En los últimos años, los fabricantes han logrado crear tejas asfálticas que imitan materiales de alta gama como la pizarra y las tejuelas de madera.",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "Wood shingles." 
          : "Tejas de madera.",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "Wood shingles provide a distinctive look for the roofline and also are a better insulator than other roofing materials. There’s a wide variety of colors and sizes to choose from, but wood shingles demand proper maintenance to ward off mold, mildew and rot." 
          : "Las tejas de madera aportan un aspecto distintivo a la línea del techo y, además, son un mejor aislante que otros materiales para techos. Existe una amplia variedad de colores y tamaños, pero las tejas de madera requieren un mantenimiento adecuado para evitar el moho, los hongos y la podredumbre.",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "Slate." 
          : "Pizarra.",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "Natural slate offers superior durability - 100 years of service life or more – and excellent fire resistance. Slate is very expensive to purchase and install, and some roofs may require modifications to support its heavy weight." 
          : "La pizarra natural ofrece una durabilidad superior (100 años de vida útil o más) y una excelente resistencia al fuego. Su compra e instalación son muy costosas, y algunos techos pueden requerir modificaciones para soportar su gran peso.",
      });
      pairs.push({
        id: "p-5.1",
        text: localize ? "Tile." 
          : "Teja.",
      });
      pairs.push({
        id: "p-5.2",
        text: localize ? "Like slate, tile offers excellent resistance to rot, fire and the elements. Comparably priced with wood shingles, tile is made of clay or concrete and generally lasts more than 50 years." 
          : "Al igual que la pizarra, las tejas ofrecen una excelente resistencia a la putrefacción, el fuego y los elementos. Con un precio similar al de las tejas de madera, las tejas están hechas de arcilla u hormigón y suelen durar más de 50 años.",
      });
      pairs.push({
        id: "p-6.1",
        text: localize ? "Metal." 
          : "Metal.",
      });
      pairs.push({
        id: "p-6.2",
        text: localize ? "Extremely durable and versatile, metal is an excellent choice for long-term performance. Reflective coatings allow it to keep roofing, cooler in the summer, and it also can be recycled, so it’s an environmentally-friendly roofing option." 
          : "Extremadamente duradero y versátil, el metal es una excelente opción para un rendimiento duradero. Sus recubrimientos reflectantes permiten mantener el techo fresco en verano y, además, es reciclable, lo que lo convierte en una opción ecológica para techos.",
      });

      return pairs;
    },

    getRoofRepair(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Roof Repairs" 
          : "Reparaciones de techos",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "offers prompt, professional repair of roofing from Denver to Pueblo and every place in between. Whether you have wind-damaged shingles, hail damage that has taken its toll, or leaks due to ice damming, we’re here to help." 
          : "Ofrecemos reparaciones rápidas y profesionales de techos desde Denver hasta Pueblo y cualquier lugar intermedio. Ya sea que tenga tejas dañadas por el viento, daños por granizo o goteras por acumulación de hielo, estamos aquí para ayudarle.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Filling an insurance claim" 
          : "Presentar una reclamación de seguro",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "If you have homeowner’s insurance and your roof is determined to be damaged, you can file a claim and have your roofing replaced for the cost of your deductible. Here are some important points to keep in mind when dealing with an insurance claim." 
          : "Si tiene seguro de vivienda y se determina que su techo está dañado, puede presentar una reclamación y solicitar su reemplazo por el costo de su deducible. Aquí tiene algunos puntos importantes que debe tener en cuenta al presentar una reclamación al seguro.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "Once an inspection request has been filed, an adjuster will make an appointment to assess the damage. He will compile measurements, take photographs and use a computer program to determine the dollar amount it should cost to replace your roof. The amount is based on a series of information ranging from size, average material costs, average labor costs in our area and your deductible. If the claim is granted, you will receive a report within a week or two by mail, sometimes with a check to handle the initial payment for a contractor." 
          : "Una vez presentada la solicitud de inspección, un perito programará una cita para evaluar los daños. Tomará medidas, tomará fotografías y usará un programa informático para determinar el costo de reemplazar su techo. El monto se basa en información como el tamaño, el costo promedio de los materiales, el costo promedio de la mano de obra en nuestra zona y su deducible. Si se aprueba la reclamación, recibirá un informe por correo en una o dos semanas, a veces con un cheque para cubrir el pago inicial del contratista.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Insurance companies work closely with roofing contractors to keep prices fair and realistic on a nationwide level. Almost every policy will provide enough money to have your roof replaced by a reputable company, minus your policy deductible. There are special types of roofs and other add-ons that can exceed the cost of your deductible, but generally speaking you will always pay the amount your policy determines." 
          : "Las compañías de seguros colaboran estrechamente con los contratistas de techos para mantener precios justos y realistas a nivel nacional. Casi todas las pólizas cubren el costo de la sustitución del techo por parte de una compañía de confianza, menos el deducible de la póliza. Existen tipos especiales de techos y otros costos adicionales que pueden superar el costo del deducible, pero, en general, siempre pagará la cantidad que determine su póliza.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Since roofing prices are set by the insurance companies, prices remain fairly uniform across the industry. If someone offers to give you back your deductible, you should be very cautious! The only way to accomplish this is by lying to the insurance company (insurance fraud) or performing work that does not meet standard building codes." 
          : "Dado que las compañías de seguros fijan los precios de los techos, estos se mantienen bastante uniformes en toda la industria. Si alguien le ofrece devolverle su deducible, ¡tenga mucho cuidado! La única forma de lograrlo es mentirle a la compañía de seguros (fraude de seguros) o realizar trabajos que no cumplen con los códigos de construcción estándar.",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Since all honest roofing companies will still charge you the cost of your deductible, it is important to find a contractor you trust and with a good reputation, rather than the cheapest bid. Chances are if you go with the “cheapest option,” you will not get any of the money back and will be getting a sub-standard job. Shop for quality and value, not dollar amounts." 
          : "Dado que todas las empresas de techado honestas le cobrarán el costo de su deducible, es importante encontrar un contratista de confianza y con buena reputación, en lugar de la oferta más barata. Si elige la opción más barata, lo más probable es que no recupere su dinero y reciba un trabajo de baja calidad. Busque calidad y valor, no cantidades en dólares.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Get a free estimate from roofers!" 
          : "¡Obtenga un presupuesto gratuito de los techadores!",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "To schedule a FREE estimate for roofing your home, call " + settingsService.get("applicationName") + " anytime. Not certain whether you need new roofing? That’s OK too – we’re the roofing contractors, homeowners turn to for honest, dependable advice. We’ll conduct a thorough inspection of your roof and explain our findings in detail. Contact AquaDuct today at" 
          : "Para programar un presupuesto GRATUITO para el techo de su casa, llame a " + settingsService.get("applicationName") + " en cualquier momento. ¿No está seguro de si necesita un techo nuevo? No se preocupe: somos los contratistas de techos a los que recurren los propietarios para obtener asesoramiento honesto y confiable. Realizaremos una inspección exhaustiva de su techo y le explicaremos nuestros hallazgos detalladamente. Contacte con AquaDuct hoy mismo al",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "For more information on our service areas, including Denver, Colorado Springs, Peyton, Castle Rock and Pueblo, kindly visit our" 
          : "Para obtener más información sobre nuestras áreas de servicio, incluidas Denver, Colorado Springs, Peyton, Castle Rock y Pueblo, visite nuestra",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "page." 
          : "página.",
      });

      return pairs;
    },

    getRoofReplace(localize) {
      var pairs = []

      pairs.push({
        id: "header-1",
        text: localize ? "Roof Replacement" 
          : "Reemplazo de techo",
      });
      pairs.push({
        id: "p-1",
        text: localize ? "In general, most roofing needs to be replaced every 10 to 25 years due to normal wear and tear. However, some situations demand early replacement: building code changes, damage caused by severe weather, manufacturer defects, and so on. Occasionally roofing will leak due to some level of improper installation. When you have a problem and need a contractor you can count on, " + settingsService.get("applicationName") + " is here to provide fast, friendly, capable service." 
          : "En general, la mayoría de los techos deben reemplazarse cada 10 a 25 años debido al desgaste normal. Sin embargo, algunas situaciones exigen un reemplazo temprano: cambios en el código de construcción, daños causados ​​por condiciones climáticas adversas, defectos de fabricación, etc. Ocasionalmente, los techos pueden tener goteras debido a una instalación incorrecta. Si tiene un problema y necesita un contratista confiable, " + settingsService.get("applicationName") + " está aquí para brindarle un servicio rápido, amable y competente.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "For expert roof replacement, call on a CertainTeed Select ShingleMaster™ roofer" 
          : "Para un reemplazo de techo experto, llame a un techador CertainTeed Select ShingleMaster™",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "proudly participates in the CertainTeed Shingle Applicator Program. This valuable instructional program provides training on every aspect of CertainTeed shingle installation, including good workmanship practices, roof systems, estimating, flashing, ventilation and product installation instructions. To become a Select ShingleMaster, we have met the following criteria:" 
          : "Participa con orgullo en el Programa de Instaladores de Tejas CertainTeed. Este valioso programa de capacitación ofrece capacitación sobre todos los aspectos de la instalación de tejas CertainTeed, incluyendo buenas prácticas de trabajo, sistemas de techo, presupuestos, tapajuntas, ventilación e instrucciones de instalación del producto. Para convertirnos en un Select ShingleMaster, cumplimos con los siguientes criterios:",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "In business for at least 5 years." 
          : "En el negocio durante al menos 5 años.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "At least 50% of our shingle installation crew, plus all job supervisors, are MSA-qualified." 
          : "Al menos el 50% de nuestro equipo de instalación de tejas, además de todos los supervisores de trabajo, están calificados por MSA.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Employ a current Shingle Quality Specialist™." 
          : "Contrate a un especialista actual en calidad de tejas™.",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Company owner passes the Business Fiscal Responsibility™ exam."
          : "Propietario de empresa aprueba el examen de Responsabilidad Fiscal Empresarial™.",
      });
      pairs.push({
        id: "p-2.6",
        text: localize ? "Hold current worker’s compensation insurance, as required by law, and liability insurance for roofing." 
          : "Mantenga un seguro de compensación laboral vigente, como lo exige la ley, y un seguro de responsabilidad civil para techos.",
      });
      pairs.push({
        id: "p.2.7",
        text: localize ? "It’s just another way AquaDuct stands apart from the competition, ensuring our team members have the knowledge and techniques needed for proper roof system installation." 
          : "Es solo otra forma en que AquaDuct se distingue de la competencia, garantizando que los miembros de nuestro equipo tengan el conocimiento y las técnicas necesarias para la instalación adecuada del sistema de techo.",
      });
      pairs.push({
        id: "heading-3",
        text: localize ? "We’re an Owens Corning™ Preferred Contractor" 
          : "Somos un contratista preferido de Owens Corning ™",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "has also been selected as an Owens Corning Roofing Preferred Contractor due to our commitment to service, reliability and excellent craftsmanship. This certification demonstrates that we have met the following criteria:" 
          : "También hemos sido seleccionados como contratistas preferentes de Owens Corning Roofing por nuestro compromiso con el servicio, la confiabilidad y la excelencia en la fabricación. Esta certificación demuestra que cumplimos con los siguientes criterios:",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "Minimum of two years operating under the same business name." 
          : "Mínimo de dos años operando bajo el mismo nombre comercial.",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "At least $1 million in general liability insurance." 
          : "Al menos un millón de dólares en seguro de responsabilidad civil general."
      });
      pairs.push({
        id: "p-3.4",
        text: localize ? "Carry all required state and local licensing & insurance." 
          : "Cumplir con todas las licencias y seguros estatales y locales requeridos.",
      });
      pairs.push({
        id: "p-3.5",
        text: localize ? "Knowledge of the latest industry standards and technology." 
          : "Conocimiento de los últimos estándares y tecnología de la industria.",
      });
      pairs.push({
        id: "p-3.6",
        text: localize ? "Dedication to customer service and professional craftsmanship." 
          : "Dedicación al servicio al cliente y artesanía profesional.",
      });
      pairs.push({
        id: "p-3.7",
        text: localize ? "When you choose Owens Corning products installed by" 
          : "Cuando elige productos Owens Corning instalados por",
      });
      pairs.push({
        id: "p-3.8",
        text: localize ? ", rest assured your home is in very good hands." 
          : ", tenga la seguridad de que su casa está en muy buenas manos.",
      });
      pairs.push({
        id: "heading-4",
        text: localize ? "We stay up-to-date on the latest roofing options" 
          : "Nos mantenemos actualizados sobre las últimas opciones de techado.",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "In any given year, the major shingle manufacturers make changes to their product lines, warranties and promotions. At" 
          : "Cada año, los principales fabricantes de tejas realizan cambios en sus líneas de productos, garantías y promociones.",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? ", we are committing to staying current with the latest developments in the industry. We review new products regularly to determine if they’re worthy of our customers’ roofing needs. We also participate in manufacturer training workshops to learn about the latest products and installation requirements." 
          : "Nos comprometemos a mantenernos al día con los últimos avances de la industria. Revisamos nuevos productos periódicamente para determinar si satisfacen las necesidades de techado de nuestros clientes. También participamos en talleres de capacitación de fabricantes para conocer los productos más recientes y los requisitos de instalación.",
      });
      pairs.push({
        id: "heading-5",
        text: localize ? "Get an estimate from the best roofers!" 
          : "¡Obtén un presupuesto de los mejores techadores!",
      });
      pairs.push({
        id: "p-5.1",
        text: localize ? "For superior installation of quality exterior building products, there’s no better choice. Give " 
          : "Para una instalación superior de productos de construcción exterior de calidad, no hay mejor opción.",
      });
      pairs.push({
        id: "p-5.2",
        text: localize ? "a call today at" 
          : "una llamada hoy al",
      });
      pairs.push({
        id: "p-5.3",
        text: localize ? "to see why others have been raving about our work for years and years. For more information on our service areas, including Denver, Colorado Springs, Peyton, Castle Rock and Pueblo, kindly visit our Contact Us page. We look forward to serving your home improvement needs." 
          : "Para descubrir por qué otros han elogiado nuestro trabajo durante años. Para más información sobre nuestras áreas de servicio, incluyendo Denver, Colorado Springs, Peyton, Castle Rock y Pueblo, visite nuestra página de Contáctenos. Esperamos atender sus necesidades de mejoras para el hogar.",
      });

      return pairs;
    },

    getRoofSigns(localize) {
      var pairs=[];

      pairs.push({
        id: "heading-1",
        text: localize ? "Signs you need a new roof" 
          : "Señales de que necesitas un techo nuevo",
      });
      pairs.push({
        id: "heading-2",
        text: localize ? "and when not to call your insurance company" 
          : "y cuándo no llamar a su compañía de seguros",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "No one wants to hear the unexpected news that they need a new roof, so it’s always best to plan ahead for the expense. Procrastination typically results in a rush to get a roof fixed, which means you could end up with a roof you don’t want, a roofing contractor you don’t like, poor-quality materials and/or bad workmanship. These factors may result in more expenses within a short period of time, so get to know the condition of your current roof and plan today for your new roof. To schedule an appointment for a professional roof inspection by AquaDuct." 
          : "Nadie quiere recibir la inesperada noticia de que necesita un techo nuevo, así que siempre es mejor planificar con antelación los gastos. La postergación suele resultar en prisas para reparar un techo, lo que significa que podría terminar con un techo que no desea, un contratista de techos que no le gusta, materiales de mala calidad o mano de obra deficiente. Estos factores pueden generar más gastos en poco tiempo, así que conozca el estado de su techo actual y planifique hoy mismo su nuevo techo. Para programar una cita para una inspección profesional de techo con AquaDuct.",
      });
      pairs.push({
        id: "heading-3",
        text: localize ? "What our roofers look for" 
          : "Lo que buscan nuestros techadores",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "Make preparing for roof replacement less stressful by keeping an eye out for signs of age or damage. Here are some of the most common warning signs your roofing is due for replacement." 
          : "Simplifique la preparación para el reemplazo del techo estando atento a señales de desgaste o daños. Estas son algunas de las señales de advertencia más comunes que indican que su techo necesita ser reemplazado.",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "Leaks or water stains." 
          : "Fugas o manchas de agua.",
      });
      pairs.push({
        id: "p-3.3",
        text: localize ? "Recurring leak problems often signal the need for a new roof. Wetness or water stains may be visible on interior ceilings, which can then be traced to the attic and the roof. When not caught early, leaks will lead to rot, mold and other costly problems." 
          : "Los problemas recurrentes de goteras suelen indicar la necesidad de un techo nuevo. La humedad o las manchas de agua pueden ser visibles en los techos interiores, cuyas raíces pueden rastrearse hasta el ático y el techo. Si no se detectan a tiempo, las goteras pueden provocar podredumbre, moho y otros problemas costosos.",
      });
      pairs.push({
        id: "p-3.4",
        text: localize ? "Storm damage." 
          : "Daños por tormenta.",
      });
      pairs.push({
        id: "p-3.5",
        text: localize ? "Depending on the severity, storms can cause enough damage to warrant complete roof replacement. Typical types of storm damage include missing and torn shingles, damaged flashing, and bruising caused by hail impact." 
          : "Dependiendo de la gravedad, las tormentas pueden causar daños suficientes como para justificar el reemplazo completo del techo. Los daños típicos incluyen tejas faltantes o rotas, tapajuntas dañados y magulladuras causadas por el impacto del granizo.",
      });
      pairs.push({
        id: "p-3.6",
        text: localize ? "Worn shingles." 
          : "Tejas desgastadas.",
      });
      pairs.push({
        id: "p-3.7",
        text: localize ? "As shingles age, their protective granule surface gradually wears away, leaving the internal mat exposed. Watch for excessive amounts of granules in the gutters, a sign of advanced wear." 
          : "A medida que las tejas envejecen, su superficie protectora granular se desgasta gradualmente, dejando la membrana interna expuesta. Preste atención a la presencia de cantidades excesivas de gránulos en las canaletas, lo cual es una señal de desgaste avanzado.",
      });
      pairs.push({
        id: "p-3.8",
        text: localize ? "Curling or blistering shingles." 
          : "Tejas que se enroscan o ampollan.",
      });
      pairs.push({
        id: "p-3.9",
        text: localize ? "Attic ventilation problems, manufacturer defects and improper installation can ruin shingles." 
          : "Los problemas de ventilación del ático, los defectos de fabricación y la instalación incorrecta pueden arruinar las tejas.",
      });
      pairs.push({
        id: "heading-4",
        text: localize ? "Should I file a claim with my homeowner’s insurance company?" 
          : "¿Debo presentar una reclamación a la compañía de seguros de mi vivienda?",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "If you’re not sure if your roof needs to be replaced due to storm damage, call" 
          : "Si no está seguro de si su techo necesita ser reemplazado debido a daños causados ​​por tormentas, llame",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "before contacting your insurance agent. Insurance companies record your inspection requests, and may even “red flag” your account if you file too many. It may be harder to file valid claims in the future if the insurance company believes you have been trying to get a free roof replacement. We can give you an honest assessment of your roof’s condition and advise if it’s necessary to file a claim." 
          : "Antes de contactar a su agente de seguros, las compañías de seguros registran sus solicitudes de inspección e incluso podrían marcar su cuenta como marcada en rojo si presenta demasiadas. Podría ser más difícil presentar reclamaciones válidas en el futuro si la compañía de seguros cree que ha estado intentando obtener un reemplazo de techo gratuito. Podemos brindarle una evaluación honesta del estado de su techo y asesorarle si es necesario presentar una reclamación."
      });
      pairs.push({
        id: "heading-5",
        text: localize ? "Get advice from the best roofing contractors in Denver & Colorado Springs" 
          : "Obtenga asesoramiento de los mejores contratistas de techos en Denver y Colorado Springs",
      });
      pairs.push({
        id: "p-5.1",
        text: localize ? "It’s always best to replace an aging roof before it displays signs of failure. For honest, dependable advice about the health of your roof, contact" 
          : "Siempre es mejor reemplazar un techo viejo antes de que muestre signos de deterioro. Para obtener asesoramiento honesto y confiable sobre el estado de su techo, comuníquese con",
      });
      pairs.push({
        id: "p-5.2",
        text: localize ? "today at" 
          : "hoy en",
      });
      pairs.push({
        id: "p-5.3",
        text: localize ? "We’re the roofing contractors homeowners turn to for exceptional service. For more information on our service areas, including Denver, Colorado Springs, Peyton, Castle Rock and Pueblo, kindly visit our Contact Us page." 
          : "Somos los contratistas de techos a los que recurren los propietarios para obtener un servicio excepcional. Para más información sobre nuestras áreas de servicio, incluyendo Denver, Colorado Springs, Peyton, Castle Rock y Pueblo, visite nuestra página de Contáctenos.",
      });

      return pairs;
    },

    getSiding(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Siding" 
          : "Vía muerta",
      });

      pairs.push({
        id: "p-1.1",
        text: localize ? "If you’re tired of scraping and painting wood siding every few years, or if you just need an updated look for your home’s current exterior, siding replacement is another of AquaDuct’s specialties. We can help you save time and maintenance expenses by choosing a siding material that complements your home and lifestyle." 
          : "Si está cansado de raspar y pintar el revestimiento de madera cada pocos años, o si simplemente necesita renovar el aspecto del exterior de su casa, el reemplazo de revestimiento es otra de las especialidades de AquaDuct. Podemos ayudarle a ahorrar tiempo y gastos de mantenimiento eligiendo un material de revestimiento que complemente su hogar y estilo de vida.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "We Use VSI Certified Installers" 
          : "Utilizamos instaladores certificados por VSI",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "AquaDuct is the siding company with years of experience installing quality siding materials on homes throughout the Front Range. We understand that our customers want the most skilled technicians working on their siding project, which is why Omar, the owner became a Certified Installer through the Vinyl Siding Institute (VSI). This certification offers you the following benefits:" 
          : "AquaDuct es la empresa de revestimientos con años de experiencia instalando materiales de calidad en viviendas de toda la región de Front Range. Entendemos que nuestros clientes buscan técnicos altamente capacitados para sus proyectos de revestimiento, por lo que Omar, el propietario, se certificó como Instalador Certificado por el Instituto de Revestimientos de Vinilo (VSI). Esta certificación le ofrece los siguientes beneficios:",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "Independent validation of our skills and knowledge." 
          : "Validación independiente de nuestras habilidades y conocimientos.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "Higher quality work requiring fewer callbacks." 
          : "Trabajo de mayor calidad que requiere menos devoluciones de llamadas.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "VSI Certified Installers must renew their certificatiosn every three years through ongoing education." 
          : "Los instaladores certificados por VSI deben renovar sus certificaciones cada tres años a través de educación continua.",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Your home deserves the best. Be sure the quality of your installation is as good as the products you’re installing by choosing AquaDuct, a VSI Certified Installer." 
          : "Su hogar merece lo mejor. Asegúrese de que la calidad de su instalación sea tan buena como la de los productos que instala eligiendo a AquaDuct, un instalador certificado por VSI.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "Visualize your dreams with Mastic" 
          : "Visualiza tus sueños con Mastic",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "AquaDuct proudly offers siding products from Mastic Home Exteriors, a brand with a long history of quality and innovation. Mastic began offering home exterior solutions in 1932, followed by the breakthrough invention of vinyl siding in 1959. Today, one of every four home exteriors remodeled with vinyl siding uses Mastic siding!" 
          : "AquaDuct se enorgullece de ofrecer revestimientos de Mastic Home Exteriors, una marca con una larga trayectoria de calidad e innovación. Mastic comenzó a ofrecer soluciones para exteriores de viviendas en 1932, seguida de la revolucionaria invención del revestimiento de vinilo en 1959. Hoy en día, ¡uno de cada cuatro exteriores de viviendas remodelados con revestimiento de vinilo usa revestimiento Mastic!",
      });
      pairs.push({
        id: "p-3.2",
        text: localize ? "Not sure what you want your home to look like? AquaDuct can give your home exterior a complete virtual makeover with Mastic’s Dreamhome Visualizer. We photograph your home, and then using computer imagery, we apply siding, shutters, trim and colors to help you explore the possibilities for an exterior remodel. You can even save and share your favorites." 
          : "¿No está seguro de cómo quiere que se vea su casa? AquaDuct puede darle a su exterior una transformación virtual completa con el Visualizador Dreamhome de Mastic. Fotografiamos su casa y, con imágenes de computadora, aplicamos revestimientos, contraventanas, molduras y colores para ayudarle a explorar las posibilidades de una remodelación exterior. Incluso puede guardar y compartir sus favoritos.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Get a quote for expert siding installation" 
          : "Obtenga una cotización para la instalación experta de revestimientos",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "If you’re ready for an exciting new look for your home, give AquaDuct a call at " 
          : "Si está listo para una nueva y emocionante apariencia para su hogar, llame a AquaDuct al",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "for a FREE estimate. We’ll discuss your options and help you make your vision for your home’s exterior come true!" 
          : "Para un presupuesto GRATUITO, hablaremos sobre sus opciones y le ayudaremos a hacer realidad su visión del exterior de su hogar.",
      });

      return pairs;
    },

    getSidingOptions(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Siding Options" 
          : "Opciones de revestimiento",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Make your home look more attractive now and sell for more money in the future by choosing a quality siding option. Let’s take a look at the advantages of the most popular siding materials." 
          : "Haga que su casa luzca más atractiva ahora y véndala por más dinero en el futuro eligiendo un revestimiento de calidad. Veamos las ventajas de los materiales de revestimiento más populares.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Vinyl" 
          : "Vinilo",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Vinyl has become the country’s most used siding because it’s durable, versatile and requires little maintenance. Forget painting; all vinyl needs is an occasional rinse with a garden hose. Available in a broad range of colors and profiles, it also stands up well to heat, cold, moisture and high winds." 
          : "El vinilo se ha convertido en el revestimiento más usado del país gracias a su durabilidad, versatilidad y bajo mantenimiento. Olvídese de pintar; el vinilo solo necesita un enjuague ocasional con una manguera. Disponible en una amplia gama de colores y perfiles, también resiste bien el calor, el frío, la humedad y los fuertes vientos.",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "Fiber cement" 
          : "fibrocemento",
      });
      pairs.push({
        id: "p-1.5",
        text: localize ? "While it does require painting every few years, fiber cement won’t rot like wood and resists water, fire and pests. In addition, it is very hail resistant. It can be molded to closely resemble wood or any other texture desired. Fiber cement may cost several times as much as vinyl upfront, but is often warranted up to 50 years." 
          : "Aunque requiere pintura cada pocos años, el fibrocemento no se pudre como la madera y es resistente al agua, al fuego y a las plagas. Además, es muy resistente al granizo. Se puede moldear para que se asemeje a la madera o a cualquier otra textura deseada. El fibrocemento puede costar varias veces más que el vinilo al principio, pero suele tener una garantía de hasta 50 años.",
      });
      pairs.push({
        id: "p-1.6",
        text: localize ? "Wood" 
          : "Madera",
      });
      pairs.push({
        id: "p-1.7",
        text: localize ? "Traditional wood requires frequent scraping, painting and repair. Its tendency to warp, chip, rot and burn makes it impractical when compared to other siding materials, but for historic homes it’s an authentic choice." 
          : "La madera tradicional requiere raspado, pintura y reparación frecuentes. Su tendencia a deformarse, astillarse, pudrirse y quemarse la hace poco práctica en comparación con otros materiales de revestimiento, pero para casas históricas es una opción auténtica.",
      });
      pairs.push({
        id: "p-1.8",
        text: localize ? "Aluminum" 
          : "Aluminio",
      });
      pairs.push({
        id: "p-1.9",
        text: localize ? "Aluminum siding offers the same low maintenance and durability of other popular siding materials, but can dent under impact. Its finish also has a tendency to become “chalky” over time, making it a less popular choice in comparison to vinyl." 
          : "El revestimiento de aluminio ofrece el mismo bajo mantenimiento y durabilidad que otros materiales de revestimiento populares, pero puede abollarse con el impacto. Su acabado también tiende a volverse 'tiza' con el tiempo, lo que lo convierte en una opción menos popular en comparación con el vinilo.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Get a quote for Siding" 
          : "Obtenga una cotización para revestimiento",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "If you’re ready to choose siding for your home, give AquaDuct a call at" 
          : "Si está listo para elegir el revestimiento para su hogar, llame a AquaDuct al",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "for a FREE estimate. We’ll discuss your options and help you make your vision for your home’s exterior come true!" 
          : "Para un presupuesto GRATUITO, hablaremos sobre sus opciones y le ayudaremos a hacer realidad su visión del exterior de su hogar.",
      });

      return pairs;
    },

    getTrim(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Trim Packages" 
          : "Paquetes de equipamiento",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "One of the most enjoyable parts of a new siding project is choosing the components that will truly make your home stand out from every other house on the block. AquaDuct’s experienced crew can assist you as you select from an exciting array of trim options. Windows and doors compose a large amount of a home’s visual surface and when used skillfully, vinyl siding trim and accents architectural features and complete the overall vision for your home." 
          : "Una de las partes más gratificantes de un nuevo proyecto de revestimiento es elegir los componentes que realmente harán que su casa destaque entre las demás casas de la cuadra. El equipo experimentado de AquaDuct puede ayudarle a elegir entre una atractiva gama de opciones de molduras. Las ventanas y puertas conforman gran parte de la superficie visual de una casa y, si se utilizan con habilidad, las molduras y acentúan las características arquitectónicas y completan la visión general de su hogar.",
      });

      pairs.push({
        id: "p-1.2",
        text: localize ? "Shutters" 
          : "Persianas",
      });

      pairs.push({
        id: "p-1.3",
        text: localize ? "Vent covers" 
          : "Cubiertas de ventilación",
      });

      pairs.push({
        id: "p-1.4",
        text: localize ? "Decorative moldings" 
          : "Molduras decorativas",
      });

      pairs.push({
        id: "p-1.5",
        text: localize ? "Window and door surrounds" 
          : "Marcos de ventanas y puertas",
      });

      pairs.push({
        id: "p-1.6",
        text: localize ? "Gable trim" 
          : "Borde del hastial",
      });

      pairs.push({
        id: "p-1.7",
        text: localize ? "All decorative trim options are available in vinyl for years of enhancement without the worries of painting, scraping or cracking." 
          : "Todas las opciones de molduras decorativas están disponibles en vinilo para años de mejora sin las preocupaciones de pintar, raspar o agrietar.",
      });

      pairs.push({
        id: "p-1.8",
        text: localize ? "Express your personality with unique trim packages" 
          : "Expresa tu personalidad con paquetes de equipamiento únicos",
      });

      pairs.push({
        id: "p-1.9",
        text: localize ? "Find out more about trim options and accessories by calling the siding contractors at AquaDuct. We can help you create a unique look that finishes off a new siding project perfectly. For all your siding needs, contact us today at" 
          : "Para obtener más información sobre las opciones de molduras y accesorios, llame a los contratistas de revestimientos de AquaDuct. Podemos ayudarle a crear una apariencia única que complemente a la perfección su nuevo proyecto de revestimiento. Para todas sus necesidades de revestimiento, contáctenos hoy mismo.",
      });

      return pairs;
    },

    getVerified(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Account Verified" 
          : "Cuenta verificada",
      });

    return pairs;
    },

    getWindows(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Windows" 
          : "Ventanas",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "If your home’s windows are failing, the purchase of replacement windows can greatly reduce heating and cooling expenses, as well as increase the overall value of your home. Though this sort of home improvement project can be daunting and often carries a sizable price tag, AquaDuct can simplify the process and help you keep costs within your budget." 
          : "Si las ventanas de su casa están fallando, comprar ventanas nuevas puede reducir considerablemente los gastos de calefacción y refrigeración, además de aumentar el valor general de su vivienda. Aunque este tipo de proyecto de mejora del hogar puede ser abrumador y a menudo conlleva un precio considerable, AquaDuct puede simplificar el proceso y ayudarle a mantener los costos dentro de su presupuesto.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "How to choose the right replacement windows" 
          : "Cómo elegir las ventanas de reemplazo adecuadas",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Here are the most important factors that will influence your purchase and help you find the best windows to meet your needs." 
          : "Aquí están los factores más importantes que influirán en su compra y le ayudarán a encontrar las mejores ventanas para satisfacer sus necesidades.",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "Window location." 
          : "Ubicación de la ventana.",
      });
      pairs.push({
        id: "p-2.3",
        text: localize ? "When selecting windows, always keep in mind the area of the home where each window will be located. Write down the location of each window you want to replace, and its functions. Do you need good air circulation in that area, or is security a more important consideration? Do you need to be able to open and clean the window? Is low maintenance important? Prioritizing the functions of the window will help you choose the best replacement for your needs." 
          : "Al seleccionar ventanas, tenga siempre en cuenta la zona de la casa donde se ubicará cada una. Anote la ubicación de cada ventana que desea reemplazar y sus funciones. ¿Necesita una buena circulación de aire en esa zona o es más importante la seguridad? ¿Necesita poder abrir y limpiar la ventana? ¿Es importante que requiera poco mantenimiento? Priorizar las funciones de la ventana le ayudará a elegir el reemplazo que mejor se adapte a sus necesidades.",
      });
      pairs.push({
        id: "p-2.4",
        text: localize ? "Energy efficiency." 
          : "Eficiencia energética..",
      });
      pairs.push({
        id: "p-2.5",
        text: localize ? "Windows are often the cause of major heat loss, discomfort and condensation problems. Today’s energy-efficient window options have dramatically reduced these issues. Use ENERGY STAR® ratings to find the window that satisfies your requirements for energy savings. Keep in mind that these ratings can also make you eligible for tax credits." 
          : "Las ventanas suelen ser la causa de importantes pérdidas de calor, incomodidad y problemas de condensación. Las opciones actuales de ventanas energéticamente eficientes han reducido drásticamente estos problemas. Utilice las clasificaciones ENERGY STAR® para encontrar la ventana que satisfaga sus necesidades de ahorro energético. Tenga en cuenta que estas clasificaciones también pueden permitirle optar a créditos fiscales.",
      });
      pairs.push({
        id: "p-2.6",
        text: localize ? "Storm windows." 
          : "Ventanas de tormenta.",
      });
      pairs.push({
        id: "p-2.7",
        text: localize ? "Storm windows not only protect against Colorado weather, they also add an extra layer of insulation to your home. Some studies estimate they reduce heat and cooling loss by more than 30%. If energy-efficient windows are out of your price range, adding storm windows could be a good alternative." 
          : "Las contraventanas no solo protegen del clima de Colorado, sino que también añaden una capa adicional de aislamiento a su hogar. Algunos estudios estiman que reducen la pérdida de calor y refrigeración en más de un 30 %. Si las ventanas de bajo consumo energético están fuera de su presupuesto, instalar contraventanas podría ser una buena alternativa.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "We use AAMA certified window installers" 
          : "Utilizamos instaladores de ventanas certificados por AAMA",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "By employing local installers certified by the American Architectural Manufacturing Association (AAMA), AquaDuct has met stringent standards for training and performance. Our attention to how our products are installed and the follow-up service are great reasons to partner with us for your home improvement project." 
          : "Al emplear instaladores locales certificados por la Asociación Americana de Manufactura Arquitectónica (AAMA), AquaDuct cumple con estrictos estándares de capacitación y rendimiento. La atención que prestamos a la instalación de nuestros productos y el servicio de seguimiento son excelentes razones para colaborar con nosotros en su proyecto de mejoras para el hogar.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "Call for a quote on replacement windows" 
          : "Solicite una cotización para el reemplazo de ventanas.",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "AquaDuct’s experienced team installs major window brands including MilGard, Plygem and Simonton Windows®. Give us a call today at" 
          : "El experimentado equipo de AquaDuct instala las principales marcas de ventanas, como MilGard, Plygem y Simonton Windows®. Llámenos hoy mismo al",
      });
      pairs.push({
        id: "p-4.2",
        text: localize ? "to learn more about the quality products and superior service we offer. You’ll be glad you did!" 
          : "Para conocer más sobre la calidad de nuestros productos y el excelente servicio que ofrecemos. ¡Se alegrará de haberlo hecho!",
      });

    return pairs;
    },

    getWindowEnergy(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Energy saving questions" 
          : "Preguntas sobre ahorro de energía",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "How are energy-saving windows different from other windows?" 
          : "¿En qué se diferencian las ventanas de ahorro energético de otras ventanas?",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "Energy-saving windows offer superior thermal resistance to save you money on your heating and cooling bills. This is accomplished by using special types of glass, glass coatings, weatherstripping and gas fills between window panes, as well as specially engineered window frames and sashes." 
          : "Las ventanas de bajo consumo ofrecen una resistencia térmica superior para ahorrarle dinero en sus facturas de calefacción y refrigeración. Esto se logra mediante el uso de vidrios especiales, revestimientos de vidrio, burletes y rellenos de gas entre los paneles, así como marcos y hojas de ventana especialmente diseñados.",
      });
      pairs.push({
        id: "header-3",
        text: localize ? "What is R-value?" 
          : "¿Qué es el valor R?",
      });
      pairs.push({
        id: "p-3.1",
        text: localize ? "R-value is a measurement of the thermal resistance of a window or other material. The higher its R-value, the better a window slows the flow of heat from inside a home to the outside, or from the outside into the house." 
          : "El valor R es una medida de la resistencia térmica de una ventana u otro material. Cuanto mayor sea su valor R, mejor retarda la ventana el flujo de calor del interior de la vivienda al exterior, o del exterior al interior de la casa.",
      });
      pairs.push({
        id: "header-4",
        text: localize ? "What is U-value?" 
          : "¿Qué es el valor U?",
      });
      pairs.push({
        id: "p-4.1",
        text: localize ? "U-value measures a window’s ability to conduct heat. The lower the U-value, the less energy is wasted and the better the window can insulate your home." 
          : "El valor U mide la capacidad de una ventana para conducir el calor. Cuanto menor sea el valor U, menor será el desperdicio de energía y mejor será el aislamiento térmico de la ventana.",
      });
      pairs.push({
        id: "header-5",
        text: localize ? "What is a Solar Heat Gain Coefficient (SHGC) rating?" 
          : "¿Qué es una clasificación de coeficiente de ganancia de calor solar (SHGC)?",
      });
      pairs.push({
        id: "p-5.1",
        text: localize ? "Solar Heat Gain Coefficient (SHGC) is a measurement of the amount of solar radiation that can pass through a window, in increments ranging from 0 to 1. Windows with a low SHGC are best used in southern climates where keeping a home cool is a concern year-round. In Colorado, where we use both heating and cooling but keeping a home warm in winter is the greater concern, we recommend a SHGC rating of less than 0.40." 
          : "El Coeficiente de Ganancia de Calor Solar (SHGC) mide la cantidad de radiación solar que puede atravesar una ventana, en incrementos de 0 a 1. Las ventanas con un SHGC bajo son ideales en climas del sur, donde mantener la casa fresca durante todo el año es una prioridad. En Colorado, donde usamos tanto la calefacción como el aire acondicionado, pero mantener la casa caliente en invierno es la mayor preocupación, recomendamos un SHGC inferior a 0,40.",
      });
      pairs.push({
        id: "header-6",
        text: localize ? "What is Low-E glass?" 
          : "¿Qué es el vidrio Low-E?",
      });
      pairs.push({
        id: "p-6.1",
        text: localize ? "Low-emissivity coatings are a microscopically thin metallic layer deposited onto the surface of glass that reflects heat in or out of a home. Different types of coatings are available, depending on what’s best for the climate." 
          : "Los recubrimientos de baja emisividad son una capa metálica microscópicamente fina que se deposita sobre la superficie del vidrio y que refleja el calor dentro o fuera de la vivienda. Existen diferentes tipos de recubrimientos, según el clima.",
      });
      pairs.push({
        id: "header-7",
        text: localize ? "What is the benefit of gas-filled windows?" 
          : "¿Cuál es el beneficio de las ventanas llenas de gas?",
      });
      pairs.push({
        id: "p-7.1",
        text: localize ? "The most popular gases used to fill the space between window panes are argon and krypton. Both of these gases are denser than oxygen, and therefore slow the transfer of heat and cold. They are found naturally in our atmosphere, and are odorless, colorless and non-toxic." 
          : "Los gases más comunes para rellenar el espacio entre los cristales de las ventanas son el argón y el criptón. Ambos gases son más densos que el oxígeno y, por lo tanto, ralentizan la transferencia de calor y frío. Se encuentran de forma natural en nuestra atmósfera y son inodoros, incoloros y no tóxicos.",
      });
      pairs.push({
        id: "header-8",
        text: localize ? "Why should I choose AquaDuct replacement windows over those found at a home improvement store?" 
          : "¿Por qué debería elegir ventanas de reemplazo AquaDuct en lugar de las que se encuentran en una tienda de mejoras para el hogar?",
      });
      pairs.push({
        id: "p-8.1",
        text: localize ? "AquaDuct carries quality replacement windows from Simonton Windows® System Home Improvement that have been specifically chosen to meet the demands of our Colorado climate. The windows you find at a local big-box home improvement center are likely stock windows that do not take into account our geographic location. In addition, you won’t enjoy the freedom to choose custom window sizes." 
          : "AquaDuct ofrece ventanas de repuesto de calidad de Simonton Windows® System Home Improvement, seleccionadas específicamente para satisfacer las exigencias del clima de Colorado. Las ventanas que encuentre en una tienda de bricolaje local probablemente sean ventanas de fábrica que no tienen en cuenta nuestra ubicación geográfica. Además, no tendrá la libertad de elegir tamaños de ventana personalizados.",
      });
      pairs.push({
        id: "header-9",
        text: localize ? "Call for a quote on replacement windows" 
          : "Solicite una cotización para el reemplazo de ventanas.",
      });
      pairs.push({
        id: "p-9.1",
        text: localize ? "AquaDuct can assist you in choosing the right window sizes, shapes, options and configurations to meet your needs and budget. Give us a call today at" 
          : "AquaDuct puede ayudarle a elegir los tamaños, formas, opciones y configuraciones de ventanas más adecuados para sus necesidades y presupuesto. Llámenos hoy mismo al",
      });
      pairs.push({
        id: "p-9.2",
        text: localize ? "to learn more about the quality products and superior service we offer. You’ll be glad you did!" 
          : "Para conocer más sobre la calidad de nuestros productos y el excelente servicio que ofrecemos. ¡Se alegrará de haberlo hecho!",
      });

    return pairs;
    },

    getWindowReplace(localize) {
      var pairs = [];

      pairs.push({
        id: "header-1",
        text: localize ? "Why replace your windows" 
          : "¿Por qué reemplazar tus ventanas?",
      });
      pairs.push({
        id: "p-1.1",
        text: localize ? "Here are the most important reasons to consider energy-efficient window replacement." 
          : "Estas son las razones más importantes para considerar el reemplazo de ventanas por otras energéticamente eficientes.",
      });
      pairs.push({
        id: "p-1.2",
        text: localize ? "Comfort" 
          : "Comodidad",
      });
      pairs.push({
        id: "p-1.3",
        text: localize ? "Windows that include a Low-E coating reflect interior heat, which keeps your home warmer in the winter while still allowing light to pass through. The U.S. Department of Energy estimates that Low-E windows cost 10-15% more than a standard window, but reduce energy loss by 30-50%!" 
          : "Las ventanas con revestimiento Low-E reflejan el calor interior, lo que mantiene su hogar más cálido en invierno y permite el paso de la luz. El Departamento de Energía de EE. UU. estima que las ventanas Low-E cuestan entre un 10 % y un 15 % más que una ventana estándar, pero reducen la pérdida de energía entre un 30 % y un 50 %.",
      });
      pairs.push({
        id: "p-1.4",
        text: localize ? "Savings" 
          : "Ahorros",
      });
      pairs.push({
        id: "p-1.5",
        text: localize ? "Depending on your current situation, the extra cost of energy-efficient windows could be recovered within the first few years of use as a result of savings on utility bills. In addition, installing ENERGY STAR-rated windows before the end of 2013 makes you eligible for a federal tax credit of up to $500." 
          : "Dependiendo de su situación actual, el costo adicional de las ventanas de bajo consumo podría recuperarse en los primeros años de uso gracias al ahorro en las facturas de servicios públicos. Además, instalar ventanas con certificación ENERGY STAR antes de finales de 2013 le permite acceder a un crédito fiscal federal de hasta $500.",
      });
      pairs.push({
        id: "p-1.6",
        text: localize ? "Increased home value" 
          : "Aumento del valor de la vivienda",
      });
      pairs.push({
        id: "p-1.7",
        text: localize ? "There is clear evidence that investments in energy efficiency lead to higher home resale values. Homeowners can expect to recover 70-80% of the cost of energy-efficient window replacement when they sell their home." 
          : "Existe evidencia clara de que las inversiones en eficiencia energética aumentan el valor de reventa de las viviendas. Los propietarios pueden esperar recuperar entre el 70 % y el 80 % del costo de reemplazar ventanas energéticamente eficientes al vender su vivienda.",
      });
      pairs.push({
        id: "header-2",
        text: localize ? "Call for a quote on replacement windows" 
          : "Solicite una cotización para el reemplazo de ventanas.",
      });
      pairs.push({
        id: "p-2.1",
        text: localize ? "AquaDuct can assist you in choosing the right replacement windows to meet your needs and budget. Give us a call today at" 
          : "AquaDuct puede ayudarle a elegir las ventanas de reemplazo adecuadas para sus necesidades y presupuesto. Llámenos hoy mismo al",
      });
      pairs.push({
        id: "p-2.2",
        text: localize ? "to learn more about the quality products we offer and to receive a FREE estimate!" 
          : "¡Para conocer más sobre los productos de calidad que ofrecemos y recibir un presupuesto GRATIS!",
      });

    return pairs;
    },

    // pairs.push({
    //   id: "",
    //   text: localize ? "" 
    //     : "",
    // });

}